export default {
  "custom": {
    linkedReference: 'Verknüpfungsreferenz',
    boot: 'Einschalten',
    shutDown: 'Ausschalten',
    notLinked: 'Nicht verknüpft',
    maxLinkedTip: 'Maximal 2 {type}-Verknüpfungen erlaubt, automatisch auf Nicht verknüpft zurückgesetzt',

    bar_Power: 'Stromsteuerung',
    bar_Video: 'Video-Umschaltung',
    bar_Vol: 'Lautstärke',
    bar_Audio: 'Audio-Umschaltung',
    bar_Serial: 'Serielle Steuerung',
    bar_Air: 'Klimaanlage',
    bar_Projection: 'Projektionsleinwand',
    bar_Remote: 'Fernbedienung',
    bar_Matrix: 'IQShare Matrix',
    youMustSelectAllThreeImagesAtTheSameTime: 'Sie müssen alle drei Bilder gleichzeitig auswählen',
    notSelected: 'Nicht ausgewählt',
    choose: 'Wählen',
    disable: 'Deaktivieren',
    "longPressAndDrag": "Lange drücken und ziehen, um die Listenreihenfolge anzupassen",
    "isrestoreDefault": "Möchten Sie den Standardzustand wiederherstellen?",
    "saveAndSync": "Speichern und synchronisieren",
    "restoreDefault": "Standard wiederherstellen",
    "limitPNG": "Es können nur PNG-Bilder hochgeladen werden!",
    "limit1M": "Die Bildgröße darf 1 MB nicht überschreiten!",
    "selectTheImage": "Bild auswählen",
    "textsuggestions": "Empfohlen: Weißes PNG-Symbol 48*48 px, kleiner als 1 MB",
    "iconLibrary": "Symbolbibliothek",
    "panelNavigationBarCustomization": "Bedienfeld-Navigationsleiste",
    "logoCustomization": "Bedienfeld-Logo"
  },
  outlook: {
    privacy: 'Bind Microsoft Organization Privacy Agreement',
    privacyContent: "Agree to",
    AuthVerify4004One: 'Bindung fehlgeschlagen: Dieser Microsoft-Mandant (ID: ',
    AuthVerify4004Two: ') wird bereits von der Organisation [',
    AuthVerify4004Three: '] verwendet. Um erneut zu binden, lösen Sie ihn zuerst von der ursprünglichen Organisation oder verwenden Sie einen anderen Microsoft-Mandanten.',
    theMicrosoftTenantIsOccupied: 'Der Microsoft-Mandant ist belegt',
    Viewtutorial: 'Bindungsanleitung anzeigen',
    checktenantID: 'Bitte überprüfen Sie, ob Ihre Mandanten-ID, Anwendungs-ID und Anwendungsschlüssel korrekt sind.',
    ErrorCode: 'Fehlercode:',
    AuthorizationFailed: 'Autorisierung fehlgeschlagen',
    Accesshasbeengranted: 'Zugriff auf die Microsoft Graph API wurde gewährt',
    successfullyauthorizedDescribe: 'Die erforderlichen Berechtigungen wurden erfolgreich erteilt. Die Konferenzraumdaten werden automatisch synchronisiert. Bitte schließen Sie diese Seite.',
    Close: 'Schließen',
    resourceID: 'Ressourcen-ID',
    dialogTips: 'Hinweise',
    theAuthorizationIsDeleted: 'Autorisierung entfernt',
    theBindingIsSuccessful: 'Bindung erfolgreich',
    theUnbindingIsSuccessful: 'Entbindung erfolgreich',
    unbindingFailed: 'Entbindung fehlgeschlagen',
    theUnbindingHasBeenUnbound: 'Entbindung abgebrochen',
    continueUnbinding: 'Outlook-Synchronisierung wird gestoppt und alle bevorstehenden Termine werden gelöscht. Entbindung fortsetzen?',
    areYouSureAboutUnbinding: 'Alle bevorstehenden Outlook-Termine werden gelöscht und die Synchronisierung wird gestoppt. Diese Aktion kann nicht rückgängig gemacht werden. Entbindung bestätigen?',
    UnbindNotSynchronized: 'Nach der Bindung werden neue Outlook-Termine für diesen Raum automatisch synchronisiert (ältere Termine werden nicht synchronisiert)',
    unbinding: 'Entbinden',
    bindUnableToSelect: 'Bereits gebunden, Auswahl nicht möglich',
    permissAThird: 'Bitte autorisieren Sie die Bindung von Drittanbieter-Ressourcen',
    resourceMailbox: 'Ressourcen-E-Mail:',
    PleasecheckID: 'Autorisierung fehlgeschlagen! Bitte überprüfen Sie, ob Ihre Mandanten-ID, Anwendungs-ID und Client-Geheimnis korrekt sind.',
    Waitingforauthorization: 'Warte auf Autorisierung...',
    Pleasecompletetheauthorization: 'Microsoft 365-Anmeldeseite wurde geöffnet. Bitte melden Sie sich mit einem Administratorkonto an, um die Autorisierung abzuschließen.',
    pleaseEnterTheTenantID: 'Bitte geben Sie die Mandanten-ID ein',
    pleaseEnterTheClientID: 'Bitte geben Sie die Anwendungs-ID ein',
    pleaseEnterTheClientSecret: 'Bitte geben Sie das Client-Geheimnis ein',
    Authorizationcompleted: 'Autorisierung abgeschlossen',
    Authorizelogin: 'Microsoft 365-Anmeldung autorisieren',
    ApplicationID: 'Mandanten-ID',
    ClientID: 'Anwendungs-ID',
    ClientSecret: 'Client-Geheimnis',
    registTipOne: 'Bitte folgen Sie der',
    registTipTwo: 'Bindungsanleitung',
    registTipThree: 'Absolvieren Sie die Azure-App-Registrierung und Berechtigungseinstellungen, bevor Sie die folgenden Felder ausfüllen.',
    MicrosoftDescribe: 'Durch die Bindung mit Microsoft 365 können in Outlook/Teams gebuchte Besprechungen automatisch mit der Q-NEX-Konsole und dem Raumplaner synchronisiert werden.',
    Addcalendarservice: 'Kalendersynchronisierungseinstellungen',
    Lasttimesynchronization: 'Letzte Synchronisierungszeit',
    Allocated: 'Zugewiesen',
    Total: 'Gesamt',
    Conferenceroomresources: 'Konferenzraumressourcen',
    Bindingtime: 'Bindungszeit',
    Bindtheplatform: 'Bindungsplattform',
    Synchronousstate: 'Synchronisierungsstatus',
    Organizationname: 'Organisationsname',
    Bindthirdpartycalendar: 'Drittanbieter-Kalender binden',
    TenantIDTip: 'Eindeutige Kennung in Azure AD',
    ApplicationIDTip: 'In Azure registrierte Anwendungs-ID',
    ApplicationSecretTip: 'Client-Geheimnis, das in Azure für die Authentifizierung generiert wurde'
  },
  "meetingManager": {
    IdleDisplayTextTable: 'Leerlauf-Anzeigetext',
    IdleDisplayText: 'Leerlauf-Anzeigetext:',
    IdleDisplayTextContent: 'Text, der angezeigt wird, wenn der Raum leer ist (Standard: „Frei“)',

    duplicateMeetingRoomName: 'Doppelter Besprechungsraumname',
    duplicateMeetingRoomNameContent: 'Ein Besprechungsraum mit dem Namen „{duplicate_content}“ existiert bereits. Bitte geben Sie einen anderen Namen ein.',
    NumberOfRoomPanels: 'Anzahl der Raumtafeln',
    "Thecurrentterminalhasbeenboundtoanotherorganization": " Das aktuelle Terminal ist bereits mit einer anderen Organisation verbunden.",
    "theTerminalNameOrIDIsDuplicated": "Der Name oder die ID des Panels ist gleich",
    theRoomNameOrIDIsDuplicated: 'Der Name des Besprechungsraums oder der Standort ist bereits vorhanden.',
    "AddMeetingRoom": "Meetingraum hinzufügen",
    "EditMeetingRoom": "Meetingraum bearbeiten",
    "MeetingRoomName": "Name des Meetingraums:",
    "Location": "Standort:",
    "ReservationApproval": "Reservierungsbestätigung:",
    "ApprovalListYes": "ja",
    "ApprovalListNo": "nein",
    "Capacity": "Kapazität:",
    "RoomStatus": "Raumstatus:",
    "BindRoomDisplay": "Raum-Panel verbinden:",
    "meeting_btnAdd": "Hinzufügen",
    "meeting_btnEdit": "Bearbeiten",
    "meeting_btnBind": "Gerät verbinden",
    "meeting_btnDel": "Löschen",
    "meeting_tableRoomName": "Name des Meetingraums",
    "meeting_tableRoomPlace": "Standort",
    "meeting_tableAppointmentApproval": "Reservierungsbestätigung",
    "meeting_tableCapacityForPeople": "Kapazität",
    "meeting_tableMeetingRoomStatus": "Raumstatus",
    "meeting_tableAvaliable": "Verfügbar",
    "meeting_tableOutofService": "Außer Betrieb",
    "meeting_tableDoorBind": "Tür verbinden",
    "meeting_tableBindNPS": "NPS verbinden",
    "meeting_tableActions": "Aktionen",
    "door_theNameOfTheTerminal": "Panel-Name:",
    "door_deviceID": "Panel-ID:",
    "door_Wallpaper": "Hintergrundbild:",
    "door_Wallpaper_text": "Empfohlene Bildgröße: 1280x800, im PNG-Format",
    "door_bindAMeetingRoom": "Meetingraum verbinden:",
    "door_table_name": "Panel-Name",
    "door_table_deviceID": "Panel-ID",
    "door_table_status": "Status",
    "door_table_ipAddress": "IP-Adresse",
    "door_table_bindAMeetingRoom": "Meetingraum verbinden",
    "door_btnAdd": "Hinzufügen",
    "door_btnBatchAdd": "Batch-Hinzufügen",
    "door_btnEdit": "Bearbeiten",
    "door_btnBatchEdit": "Batch-Bearbeiten"
  },
  "InputSourcesLinkage": {
    "configurationAddTitle": "Konfiguration hinzufügen",
    "configurationEditTitle": "Konfiguration bearbeiten",
    "dialogConfigName": "Konfigurationsname",
    "selectNMPAndNDP": "Zielgeräte",
    "powerControl": "Stromsteuerung",
    "executeCommand": "Tun",
    "tableConfigName": "Konfigurationsname",
    "selectConfig": "Bitte konfigurieren Sie"
  },
  "NPS": {
    "Relay": "Relais",
    "RelaySettings": "Relais-Einstellungen",
    "DevicePower": "Gerätesteuerung der Stromversorgung",
    "DeviceElevation": "Höhensteuerung",
    "LinageWithNPSPower": "Verknüpfung mit der NPS-Stromversorgung",
    "PresentationSwitch": "Präsentationsschalter",
    "Duplicate": "Duplizieren",
    "LinkagewithNPSPowe": "Verknüpfung mit der NPS-Stromversorgung"
  },
  "PTZ": {
    "powerSupplyON": "Ein",
    "powerSupplyOFF": "Aus",
    "LEFT": "Links",
    "RIGHT": "Rechts",
    "UP": "Oben",
    "DOWN": "Unten",
    "HOME": "Start",
    "ENLARGE": "Vergrößern",
    "REDUCTION": "Verkleinern",
    "StopMovement": "Bewegung stoppen",
    "STOP": "Zoom stoppen",
    "FOCUS": "Fokus",
    "SET_PRESETS0": "SETZE_VOREINSTELLUNG0",
    "SET_PRESETS1": "SETZE_VOREINSTELLUNG1",
    "SET_PRESETS2": "SETZE_VOREINSTELLUNG2",
    "SET_PRESETS3": "SETZE_VOREINSTELLUNG3",
    "SET_PRESETS4": "SETZE_VOREINSTELLUNG4",
    "SET_PRESETS5": "SETZE_VOREINSTELLUNG5",
    "SET_PRESETS6": "SETZE_VOREINSTELLUNG6",
    "SET_PRESETS7": "SETZE_VOREINSTELLUNG7",
    "SET_PRESETS8": "SETZE_VOREINSTELLUNG8",
    "SET_PRESETS9": "SETZE_VOREINSTELLUNG9",
    "USE_PRESETS0": "VERWENDE_VOREINSTELLUNG0",
    "USE_PRESETS1": "VERWENDE_VOREINSTELLUNG1",
    "USE_PRESETS2": "VERWENDE_VOREINSTELLUNG2",
    "USE_PRESETS3": "VERWENDE_VOREINSTELLUNG3",
    "USE_PRESETS4": "VERWENDE_VOREINSTELLUNG4",
    "USE_PRESETS5": "VERWENDE_VOREINSTELLUNG5",
    "USE_PRESETS6": "VERWENDE_VOREINSTELLUNG6",
    "USE_PRESETS7": "VERWENDE_VOREINSTELLUNG7",
    "USE_PRESETS8": "VERWENDE_VOREINSTELLUNG8",
    "USE_PRESETS9": "VERWENDE_VOREINSTELLUNG9"
  },
  "schedule": {
    "startLinkPowerStart": "Einschalten (CBXs Relais)  ",
    "startLinkPowerStop": "Ausschalten (CBXs Relais)  ",
    "dehumidification": "Trocken  ",
    "airSupply": "Lüfter  ",
    "masterControl": "Haupt:  ",
    "powerSupply": "Strom  ",
    "lockScreen": "Sperre  ",
    "RecordingControl": "Aufnahme-Steuerung  ",
    "RecordingControlSystem": "Vorlesungsaufzeichnungssystem  ",
    "LiquidCrystal": "Interaktives Flachbildschirm-Panel  ",
    "projector": "Projektor  ",
    "othertype": "Sonstiges  ",
    "childLock": "Kindersicherung  ",
    "energySaving": "Energiesparen  ",
    "signalSourceSwitching": "Eingangsquelle  ",
    "other": "Andere Funktionen:  ",
    "otherFunction": "Funktion  ",
    "send": "Senden  ",
    "ON": "EINSCHALTEN  ",
    "OFF": "AUSGESCHALTET  ",
    "btnAddSchedule": "Wiederherstellen  ",
    "EditSchedulelist": "Zeitplaner bearbeiten  ",
    "AddSchedulelist": "Zeitplaner hinzufügen  ",
    "RestoreSchedulelist": "Wiederherstellen  ",
    "btn": "Abbrechen  ",
    "btnNewList": "Neuer Zeitplaner  ",
    "ListName": "Name  ",
    "Cannotquit": "Obligatorisch  ",
    "NOCannotquit": "NEIN  ",
    "ListValidityPeriod": "Gültigkeitszeitraum  ",
    "ListDescription": "Beschreibung  ",
    "currentSchedule": "Zeitplaner-Liste  ",
    "historySchedule": "Historien-Liste  ",
    "selectTime": "Zeit  ",
    "taskType": "Aufgabentyp  ",
    "selectBroadcasting": "Übertragung  ",
    "selectDeviveControl": "Gerätesteuerung  ",
    "newSchedule": "Neue Aufgabe  ",
    "newChecklist": "Neue Checkliste  ",
    "titleStatus": "Status  ",
    "titleType": "Typ  ",
    "titleStartTime": "Startzeit  ",
    "titleEndTime": "Endzeit  ",
    "titleRepeat": "Wiederholen  ",
    "titleName": "Name  ",
    "titleAction": "Aktion  ",
    "tableEnabled": "Aktiviert  ",
    "tablePaused": "Pausiert  ",
    "tableEdit": "Bearbeiten  ",
    "tableDelete": "Löschen",
    "tableVolumeEdit": "Übertragungslautstärke  ",
    "tableBroadcastTitle": "Titel  ",
    "tableBroadcastContent": "Inhalt  ",
    "tableBroadcastList": "Liste  ",
    "tableBroadcast": "Zwanghaft  ",
    "btnRemoveCompletely": "Vollständig entfernen  ",
    "btnEnabled": "Aktiviert  ",
    "btnPaused": "Pausiert  ",
    "btnDelete": "Löschen  ",
    "repeat0": "MO  ",
    "repeat1": "DI  ",
    "repeat2": "MI  ",
    "repeat3": "DO  ",
    "repeat4": "FR  ",
    "repeat5": "SA  ",
    "repeat6": "SO  ",
    "dialogTitleAdd": "Neue Geräte-Steuerungsaufgabe  ",
    "dialogTitleEdit": "Geräte-Steuerungsaufgabe bearbeiten  ",
    "newBroadcastingSchedule": "Neue Übertragungsaufgabe  ",
    "editBroadcastingSchedule": "Übertragungsaufgabe bearbeiten  ",
    "chooseDevice": "Gerät wählen  ",
    "timeSetting": "Zeiteinstellung  ",
    "controlBroadcasting": "Übertragungsoption  ",
    "controlOption": "Steuerungsoption  ",
    "scheduleName": "Aufgabenname:  ",
    "destination": "Ziel  ",
    "timeTilte": "Zeit  ",
    "repeatTitle": "Wiederholen  ",
    "dialogRepeat0": "MO  ",
    "dialogRepeat1": "DI  ",
    "dialogRepeat2": "MI  ",
    "dialogRepeat3": "DO  ",
    "dialogRepeat4": "FR  ",
    "dialogRepeat5": "SA  ",
    "dialogRepeat6": "SO  ",
    "dialogOnceType": "Einmal  ",
    "dialogRepeatType": "Wiederholen  ",
    "mainPower": "Hauptstrom  ",
    "powerControl": "Stromsteuerung  ",
    "tableDisplayInputSwitch": "Anzeige-Eingangsumschalter  ",
    "tableAirConditioning": "Klimaanlage  ",
    "tableProjectionScreen": "Projektion Bildschirm  ",
    "tableElectronicLock": "Elektrisches Schloss  ",
    "interactiveFlatPanel": "Interaktives Flachbildschirmpanel  ",
    "displayInputSwitch": "Anzeige-Eingangsumschalter  ",
    "speakerVolume": "Lautsprecherlautstärke  ",
    "MICVolume": "Mikrofonlautstärke  ",
    "ProjectionScreen": "Projektion Bildschirm  ",
    "ElectronicLock": "Elektrisches Schloss  ",
    "AirConditioning": "Klimaanlage",
    "AirConditioningPower": "Leistung  ",
    "AirConditioningModel": "Modell  ",
    "AirConditioningTEMP": "TEMP  ",
    "AirConditioningFanSpeed": "Lüftergeschwindigkeit  ",
    "OPEN": "ÖFFNEN  ",
    "CLOSE": "SCHLIESSEN  ",
    "UP": "OBEN  ",
    "DOWN": "UNTEN  ",
    "PowerOFF": "AUS  ",
    "PowerON": "AN  ",
    "ModelAuto": "Automatisch  ",
    "ModelCool": "Kühlen  ",
    "ModelHeat": "Heizen  ",
    "ModelAir": "Luftseite  ",
    "TEMPLow": "Niedrig  ",
    "TEMPMiddle": "Mittel  ",
    "TEMPHigh": "Hoch  ",
    "btnSave": "Speichern  ",
    "btnNext": "NÄCHSTE  ",
    "StartTime": "Startzeit  ",
    "StopTime": "Stoppzeit  ",
    "Mandatory": "Pflicht  ",
    "Video": "Video & Audio  ",
    "Notification": "Benachrichtigung  ",
    "btnFile": "Wählen Sie eine Mediendatei aus  ",
    "LastingTime": "Dauer  ",
    "textTitle": "Titel  ",
    "textContent": "Inhalt  ",
    "textTitleLetters": "Weniger als 60 Zeichen  ",
    "textContentLetters": "Weniger als 320 Zeichen  ",
    "CannotquitYES": "JA  ",
    "CannotquitNo": "Nein  ",
    "YES": "JA  ",
    "No": "Nein  ",
    "delTitleContent": "Möchten Sie diesen Scheduler wirklich löschen?  ",
    "delTitleListContent": "Der gelöschte Scheduler wird in die Historienliste verschoben und kann wiederhergestellt werden  ",
    "deleListTitle": "Scheduler löschen?  ",
    "delTitleListContent1": "Das Löschen des Schedulers führt dazu, dass die damit verbundenen Aufgaben gelöscht werden, bitte bestätigen Sie.  ",
    "deleListTitle1": "Möchten Sie diesen Scheduler wirklich löschen?  ",
    "delTitle": "Löschen?  ",
    "btnConfirm": "Bestätigen  ",
    "coxAll": "ALLE  ",
    "coxBroadcasting": "Übertragung  ",
    "coxDeviveControl": "Gerätesteuerung  ",
    "rdMandatory": "JA  ",
    "noRdMandatory": "NEIN  ",
    "startDate": "Startdatum  ",
    "endedDate": "Enddatum  ",
    "or": "-  ",
    "broadcastingType": "Typ",
    "ChooseTime": "Wählen Sie die Uhrzeit  ",
    "ChooseDate": "Wählen Sie das Datum  ",
    "newScheduleList": "Neuer Zeitplaner  ",
    "editScheduleList": "Zeitplaner bearbeiten  ",
    "listName": "Name  ",
    "listValidityPeriod": "Gültigkeitszeitraum  ",
    "listDescription": "Beschreibung  ",
    "cancel": "Abbrechen  ",
    "confirm": "Bestätigen  ",
    "save": "Speichern  ",
    "addSuccess": "Erfolgreich hinzugefügt!  ",
    "addError": "Fehler beim Hinzufügen!  ",
    "editSuccess": "Erfolgreich bearbeitet!  ",
    "editError": "Fehler beim Bearbeiten!  ",
    "delSuccess": "Erfolgreich gelöscht!  ",
    "delError": "Fehler beim Löschen!  ",
    "restoreSuccess": "Zeitplan-Liste erfolgreich wiederhergestellt  ",
    "restoreError": "Fehler beim Wiederherstellen der Zeitplan-Liste  ",
    "restoreTitleContent": "Diese Zeit überschneidet sich mit einer Zeit im Zeitplan, bitte wählen Sie erneut  ",
    "Enabled": "Aktiviert  ",
    "Paused": "Pausiert  ",
    "Title": "Titel:  ",
    "Content": "Inhalt:  ",
    "errorScheduleNameRequired": "Der Name der Aufgabe muss ausgefüllt werden  ",
    "errorDeviceRequired": "Bitte wählen Sie das Zielgerät aus  ",
    "deleTitle": "Sind Sie sicher, dass Sie diese Aufgabe löschen möchten?  ",
    "loopList": "Wiederholungs-Liste  ",
    "errorPleaseDateRange": "Bitte wählen Sie einen Datumsbereich aus  ",
    "addError_2009": "Doppelte Zeitplaner-Namen  ",
    "conflicts": "Die Zeit der Aufgabe überschneidet sich mit den folgenden:  ",
    "Pleaseagain": "Bitte erneut eingeben  ",
    "errorScheduleName": "Aufgabenname  ",
    "errorListName": "Zeitplaner-Name  ",
    "today": "Heute  ",
    "yesterday": "Gestern  ",
    "thisWeek": "Diese Woche  ",
    "lastWeek": "Letzte Woche  ",
    "lastMonth": "Letzten Monat  ",
    "thisMonth": "Diesen Monat  ",
    "times": "Mal  ",
    "TimeConflicts": "Zeitkonflikte  ",
    "editError_2006": "Gerät nicht gefunden  ",
    "editError_2010": "Doppelte Aufgabenbezeichnung  ",
    "ListTimeExpired": "Die Zeit des Zeitplans ist abgelaufen, bitte wählen Sie erneut  ",
    "TimeExpired": "Zeit abgelaufen  ",
    "ControlOption": "Kontrolloption fehlt  ",
    "Pleaseleastone": "Bitte wählen Sie mindestens eine Kontrolloption aus  ",
    "Enter": "Eingeben  ",
    "TitleFilled": "Der Titel muss ausgefüllt werden  ",
    "ContentFilled": "Der Inhalt muss ausgefüllt werden  ",
    "PleaseMediaFile": "Bitte wählen Sie eine Mediendatei aus  ",
    "PleaseSchedule": "Bitte wählen Sie eine Aufgabe aus  ",
    "delTitleScheduleContent": "Die gelöschte Aufgabe kann nicht wiederhergestellt werden.  ",
    "deleTitleSchedule": "Sind Sie sicher, dass Sie diese Aufgabe löschen möchten?  ",
    "deleteScheduleTitle": "Bitte wählen Sie die zu löschende Aufgabe aus  ",
    "PleaseFillColumn": "Bitte geben Sie den Namen des Zeitplans ein  ",
    "PleaseDate": "Bitte wählen Sie das Datum aus  ",
    "Previous": "Zurück  ",
    "RemoteControl": "Fernbedienung  ",
    "taskhasexpired": "Diese Aufgabe ist abgelaufen, bitte kontaktieren Sie den Ersteller, um die Zeit zu aktualisieren.  ",
    "execute": "Ausführen  ",
    "broadcastingList": "Sende-Liste  ",
    "volumeSuccess": "Lautstärke erfolgreich eingestellt  ",
    "volumeFailed": "Lautstärkeeinstellung fehlgeschlagen  "
  },
  "Automation": {
    "nameDuplicate": "Automatischer Aufgabenname duplizieren  ",
    "Automation": "Automatisierung  ",
    "if": "Wenn:  ",
    "ifContent": "Der Abschnitt 'WENN' ermöglicht es, Bedingungen basierend auf Sensordaten festzulegen. Wählen Sie den Sensor und geben Sie Bedingungen wie 'Temperatur > 26°C' an.  ",
    "then": "Dann:  ",
    "thenContent": "Der Abschnitt 'DANN' ermöglicht es, Geräte auszuwählen und Aktionen für diese zu definieren. Wählen Sie Geräte wie NMP1, NMP2 und definieren Sie Aktionen wie 'Einschalten + Kühlen' für Klimaanlagen.  ",
    "btnDelete": "Löschen  ",
    "Add": "Hinzufügen  ",
    "taskName": "Aufgabenname  ",
    "dialogTaskName": "Aufgabenname:  ",
    "Statue": "Status  ",
    "DevicesApplied": "Angewendete Geräte  ",
    "Operation": "Betrieb  ",
    "AirConditioningPower": "Strom  ",
    "AirConditioningModel": "Modell  ",
    "AirConditioningFanSpeed": "Lüftergeschwindigkeit  ",
    "bold": "Schwingen  ",
    "selectTask": "Bitte wählen Sie eine Aufgabe aus  ",
    "autoTaskAdd": "Automatisierungsaufgabe hinzufügen  ",
    "autoTaskEdit": "Automatisierungsaufgabe bearbeiten  ",
    "Destination": "Ziel  ",
    "selectConditions": "Bitte geben Sie die Aktion an, die Sie ausführen möchten.  ",
    "selectDestination": "Bitte wählen Sie das Zielgerät(e) NMP aus und geben Sie dann die Aktion an, die Sie ausführen möchten  ",
    "AirConditioningTEMP": "Temperatur  ",
    "AirConditioningHumidness": "Feuchtigkeit  ",
    "noData": "Keine Aufgaben hinzugefügt. Klicken Sie auf \"Hinzufügen\", um Aufgaben hinzuzufügen.  "
  },
  "rs232Translation": {
    "reliveBinding": "Trennen  ",
    "RELIVEBINDING": "Trennen",
    "ACTO": "ACTO",
    "AMENA": "AMENA",
    "APPOTRONICS": "APPOTRONICS",
    "APTI": "APTI",
    "ASEE": "ASEE",
    "ASK": "ASK",
    "AUCMA": "AUCMA",
    "AUX": "AUX",
    "BARCO": "BARCO",
    "BENQ": "BENQ",
    "BOERKA": "BOERKA",
    "BOXLIGHT": "BOXLIGHT",
    "Canon": "Canon",
    "CARRIER": "CARRIER",
    "CHANGHONG": "CHANGHONG",
    "CHIGO": "CHIGO",
    "CHRISTIE": "CHRISTIE",
    "Chunlan": "Chunlan",
    "COSTAR": "COSTAR",
    "CROWN": "CROWN",
    "CX": "CX",
    "DAEWOO": "DAEWOO",
    "DAIKIN": "DAIKIN",
    "DIGITEL": "DIGITEL",
    "DONGBAO": "DONGBAO",
    "EIKI": "EIKI",
    "electra": "electra",
    "Electrolux": "Electrolux",
    "EPSON": "EPSON",
    "FEILU": "FEILU",
    "FOUNDER": "FOUNDER",
    "Frestec": "Frestec",
    "Fujitsu": "Fujitsu",
    "Galanz": "Galanz",
    "GREE": "GREE",
    "Haier": "Haier",
    "Hisense": "Hisense",
    "HITACHI": "HITACHI",
    "HP": "HP",
    "HUIFENG": "HUIFENG",
    "InFocus": "InFocus",
    "IQ": "IQ",
    "JVC": "JVC",
    "KODAK": "KODAK",
    "LANGER": "LANGER",
    "LENOVO": "LENOVO",
    "LG": "LG",
    "LITTLESWAN": "LITTLESWAN",
    "LUMENS": "LUMENS",
    "McQuay": "McQuay",
    "Microtek": "Microtek",
    "Mitsubishi": "Mitsubishi",
    "NANFENG": "NANFENG",
    "NEC": "NEC",
    "OPTOMA": "OPTOMA",
    "PALOROID": "PALOROID",
    "panisonic": "panisonic",
    "PHILIP": "PHILIP",
    "PJD": "PJD",
    "PLUS": "PLUS",
    "POLAROID": "POLAROID",
    "PROPIX": "PROPIX",
    "PROXIMA": "PROXIMA",
    "RAYBO": "RAYBO",
    "ROWA": "ROWA",
    "Samsung": "Samsung",
    "SANYO": "SANYO",
    "SAST": "SAST",
    "SEEMILE": "SEEMILE",
    "SHARP": "SHARP",
    "shengfeng": "shengfeng",
    "Shinco": "Shinco",
    "shuanglu": "shuanglu",
    "Sony": "Sony",
    "SOVA": "SOVA"
  },
  "VcbEdit": {
    "VcbNameNoNull": "Der Name des CBX darf nicht leer sein  ",
    "BrandNoNull": "Die Marke darf nicht leer sein  ",
    "ModelNoNull": "Das Modell darf nicht leer sein  ",
    "AcNoNull": "Die Klimaanlagensteuerung darf nicht leer sein  ",
    "RcNoNull": "Die Fernbedienung darf nicht leer sein"
  },
  "route": {
    customize: 'Anpassen',
    "InputSourcesLinkage": "Eingabequellenverknüpfung  ",
    "Automation": "Automatisierung  ",
    "dashboard": "Dashboard",
    "i18n": "I18n  ",
    "organizationMge": "Gruppen  ",
    "userMge": "Benutzer  ",
    "authorityMge": "Berechtigungen  ",
    "roleMge": "Rollen  ",
    "equipmentMge": "Geräte  ",
    "workstationMge": "Medienserver  ",
    "cloudDiskMge": "Speichersteuerung  ",
    "operationLog": "Betriebsprotokoll  ",
    "setting": "Einstellungen  ",
    "resourceMge": "Ressourcenmanagement  ",
    "storageMge": "Speicherverwaltung  ",
    "interfaceRename": "Schnittstellenumbenennung  ",
    "processorManager": "Prozessormanagement  ",
    "projectorCode": "Seriencode-Verwaltung  ",
    "projectorCodeSetting": "Seriencode-Einstellungen  ",
    "RepairLog": "Reparaturprotokoll  ",
    "remoteControl": "Fernbedienungscode  ",
    "acCode": "Klimaanlagensteuerungscode  ",
    "cardMge": "Karten  ",
    "cardLog": "Kartenbenutzungsprotokoll  ",
    "cardManager": "Kartenverwaltung  ",
    "meetingManager": "Besprechung  ",
    "meetingRoomManager": "Raummanagement  ",
    "meetingDoorManager": "Panelverwaltung"
  },
  "navbar": {
    "logOut": "Abmelden  ",
    "dashboard": "Dashboard  ",
    "screenfull": "Vollbild  ",
    "language": "Sprache  ",
    "userConsole": "Q-NEX Konsole  ",
    "BackTianwa": "Zurück zu Tianwa"
  },
  "feedback": {
    "Feedback": "Feedback  ",
    "email": "Bitte hinterlassen Sie Ihre E-Mail für unser Feedback.  ",
    "content": "Willkommen und hinterlassen Sie Nachrichten, um unsere Produkte zu verbessern. Vielen Dank für Ihre Kommentare.  ",
    "submit": "Absenden  ",
    "emailNoEmpty": "E-Mail darf nicht leer sein  ",
    "emailTrueRule": "Bitte geben Sie das richtige E-Mail-Format ein  ",
    "contentNoEmpty": "Der Inhalt darf nicht leer sein  ",
    "feedbackSuccess": "Feedback erfolgreich  ",
    "feedbackFailed": "Feedback fehlgeschlagen  ",
    "emailNoChinese": "Das Postfach darf keine chinesischen Zeichen enthalten  ",
    "emailLength": "Zwischen 5 und 100 Zeichen lang  ",
    "GroupNameLength": "Zwischen 1 und 20 Zeichen lang  ",
    "emailSpecialString": "Dieses Eingabefeld darf keine speziellen Zeichenfolgen enthalten"
  },
  "login": {
    "title": "WILLKOMMEN  ",
    "logIn": "Einloggen  ",
    "username": "Benutzername  ",
    "password": "Passwort  ",
    "any": "irgendein  ",
    "thirdparty": "Oder verbinden Sie sich mit  ",
    "thirdpartyTips": "Kann nicht lokal simuliert werden, also kombinieren Sie bitte Ihre eigene Geschäftssimulation!!!  ",
    "placeholder": "[  \n  \"Benutzername\",  \n  \"Passwort\",  \n  \"Verifizierungscode\"  \n]  ",
    "userNameTitle": "Falscher Benutzername!  ",
    "forget": "Vergessen?  ",
    "loginTitle0": "Erfolgreich eingeloggt!  ",
    "loginTitle1000": "Falscher Benutzername oder Passwort!  ",
    "loginTitle1001": "Benutzername und Passwort müssen ausgefüllt werden!  ",
    "loginTitle1002": "Verifizierungscode muss ausgefüllt werden!  ",
    "loginTitle1003": "Benutzerstatus ist illegal, Login fehlgeschlagen!  ",
    "loginTitle1004": "Fehler im Verifizierungscode!  ",
    "loginTitle1005": "Nicht eingeloggt, bitte loggen Sie sich zuerst ein!  ",
    "loginTitleUserName": "Benutzername muss ausgefüllt werden!  ",
    "loginTitlePwd": "Passwort muss ausgefüllt werden!  ",
    "loginTitleVercode": "Verifizierungscode muss ausgefüllt werden!  ",
    "errorLogin": "Unzureichende Benutzerrechte, Anmeldung nicht möglich!  ",
    "titleLoginNameFormat": "Es muss aus Zeichen oder Zeichen und Zahlen bestehen."
  },
  "organizationMge": {
    "CanTDragTop": "Kann nicht zum Root wechseln  ",
    "prefixCannotBeEmpty": "Das Präfix des Super-Administratorkontos darf nicht leer sein  ",
    "enterEnglishLetters": "Das Präfix des Super-Administratorkontos darf nur aus englischen Buchstaben und Zahlen bestehen  ",
    "dateNotSelected": "Das Startdatum des Streaming-Service-Gültigkeitszeitraums wurde nicht ausgewählt  ",
    "btnAddChild": "Untergeordnete hinzufügen  ",
    "btnAddSibling": "Bruder hinzufügen  ",
    "title": "Tipp:  ",
    "againTitle": "Bitte bestätigen Sie erneut:  ",
    "sort": "Sortieren:  ",
    "realName": "Echter Name:  ",
    "titleShooleRq": "Dieses Feld muss ausgefüllt werden  ",
    "titleShooleNub": "weniger als 100 Zeichen  ",
    "schoolName": "Gruppenname:  ",
    "type": "Gruppentyp:  ",
    "accountPrefix": "Administrator-Konto:  ",
    "organization": "Händler  ",
    "terminalMechanism": "Endbenutzer  ",
    "equipmentNum": "Gerätenummer:  ",
    "organizationNum": "Anzahl der Terminalgruppen:  ",
    "adminName": "Administrator-Konto:  ",
    "adminPwd": "Administrator-Passwort:  ",
    "edit": "Bearbeiten  ",
    "add": "Hinzufügen  ",
    "del": "Löschen  ",
    "addSuccess": "Erfolgreich hinzugefügt  ",
    "addError": "Hinzufügen fehlgeschlagen!  ",
    "editSuccess": "Erfolgreich bearbeitet  ",
    "editError": "Bearbeiten fehlgeschlagen!  ",
    "delSuccess": "Erfolgreich gelöscht!  ",
    "delWarn": "Diese Gruppe mit gebundenen Geräten kann nicht gelöscht werden  ",
    "delError": "Löschen fehlgeschlagen!  ",
    "cancel": "Abbrechen  ",
    "confirm": "Bestätigen  ",
    "save": "Speichern  ",
    "TrialWorkstation": "Sie befinden sich derzeit im Testmodus, in dem nur maximal 3 Terminalgeräte gestreamt und live übertragen werden können.  ",
    "Normal": "Normal  ",
    "NormalWorkstation": "Der Gültigkeitszeitraum Ihres Streaming-Services ist vom  ",
    "to": "bis zum  ",
    "Advent": "Advent  ",
    "AdventWorkstationOne": "Ihr Streaming-Service läuft am  ",
    "AdventWorkstationTwo": ", bitte kontaktieren Sie Ihren Agenten, um rechtzeitig für die normale Nutzung zu verlängern.  ",
    "Expired": "Abgelaufen  ",
    "ExpiredWorkstation": "Ihr Streaming-Dienst ist abgelaufen, bitte kontaktieren Sie Ihren Agenten, um rechtzeitig zu verlängern.  ",
    "admin": "Administrator:  ",
    "serviceState": "Streaming-Medien-Dienst:  ",
    "serviceStateLIST": "Streaming-Medien-Dienst  ",
    "ValidityPeriod": "Gültigkeitsdauer:  ",
    "ValidityPeriodLIST": "Gültigkeitsdauer  ",
    "Trial": "Test  ",
    "Permanent": "Permanent  ",
    "AnnualBilling": "Jährliche Abrechnung  ",
    "mediaValidityPeriod": "Gültigkeitsdauer:  ",
    "mediaValidityPeriodLIST": "Gültigkeitsdauer  ",
    "contactInformation": "Kontaktdaten (für Streaming-Dienstverlängerungserinnerung)  ",
    "company": "Firmenname:  ",
    "email": "E-Mail:  ",
    "phone": "Telefon:  ",
    "StartDate": "Startdatum  ",
    "EndDate": "Enddatum  ",
    "To": "Bis  ",
    "TerminalName": "Endbenutzername  ",
    "Competence": "Administrator  ",
    "operate": "Betrieb  ",
    "statusFilter": "Statusfilter  ",
    "disableStreaming": "Möchten Sie den Streaming-Dienst wirklich deaktivieren?  ",
    "enableStreaming": "Möchten Sie den Streaming-Dienst wirklich aktivieren?  ",
    "disableStreamingContent": "Wenn der Streaming-Dienst deaktiviert ist, kann die Gruppe die damit verbundenen Funktionen wie Broadcasting und Live-Streaming nicht nutzen.  ",
    "enableStreamingContent": "Bitte ändern Sie die Gültigkeitsdauer für Gruppen mit abgelaufenem Streaming-Dienst.  ",
    "search": "Geben Sie den Organisationsnamen ein  ",
    "optionsYearZero": "Bitte wählen",
    "optionsYearOne": "Ein Jahr  ",
    "optionsYearTwo": "Zwei Jahre  ",
    "optionsYearThree": "Drei Jahre  ",
    "dialogName": "Name:  ",
    "detTitle": "Das Löschen der Gruppe führt dazu, dass alle Inhalte darunter ebenfalls gelöscht werden.  ",
    "groupDelTitle": "Sind Sie sicher, dass Sie diese Gruppe löschen möchten?  ",
    "delTitle": "Löschen?  ",
    "delTitleContent": "Der ausgewählte Inhalt wird aus der Datenbank gelöscht. Dieser Vorgang kann nicht rückgängig gemacht werden. Sind Sie sicher, dass Sie fortfahren möchten?  ",
    "delCancelButton": "Abbrechen  ",
    "delConfirmButton": "Bestätigen  ",
    "copySuccess": "Der Inhalt wurde in die Zwischenablage kopiert.  ",
    "copyError": "Der Browser unterstützt keine automatische Kopie  ",
    "error1200": "Doppelt vorhandener Gruppenname  ",
    "error1201": "Duplizierung von Gruppe oder Gruppen-ID  ",
    "error1202": "Die maximale Anzahl an anschließbaren Geräten wurde überschritten  ",
    "error1203": "Doppelt vorhandener Benutzername  ",
    "error1204": "Es gibt bereits eine Gruppe mit dem gleichen Namen auf der gleichen Ebene  ",
    "error1210": "Bitte geben Sie das Administrator-Passwort ein  ",
    "warningGroup": "Wählen Sie eine Gruppe!  ",
    "warningTerminal": "Die Terminalgruppe kann keine Untergruppen erstellen!  ",
    "account": "Doppelte Konten  ",
    "titleOrganization": "Hinweis: Das Kontopräfix wird auf Organisationsebene festgelegt. Alle Benutzerkonten dieser Organisation teilen sich dasselbe Präfix.",
    "all": "Alle"
  },
  "userMge": {
    "nickName": "Spitzname  ",
    "contentWithBrand": "Geben Sie die Marke oder das Modell ein  ",
    "contentwithIp": "Nach Gerätenamen oder IP-Adresse suchen.  ",
    "btnAdd": "Neuer Benutzer  ",
    "btnDelete": "Löschen  ",
    "btnDownload": "Vorlage herunterladen  ",
    "btnImport": "Massenimport  ",
    "btnExport": "Herunterladen  ",
    "btnDisable": "Deaktivieren  ",
    "btnEnable": "Aktivieren  ",
    "accountType": "Filtern nach Rolle  ",
    "organizationName": "Filtern nach Gruppe  ",
    "content": "Suchen  ",
    "systemAccount": "Benutzer-ID  ",
    "idCardNumber": "Mitarbeiter-ID  ",
    "customizeAccount": "Benutzerkonto anpassen  ",
    "userName": "Name  ",
    "licenseNum": "Lizenznummer  ",
    "phone": "Telefon  ",
    "email": "E-Mail  ",
    "role": "Rolle  ",
    "status": "Status  ",
    "affiliatedOrganization": "Gruppen  ",
    "roleTypeList1": "Allgemeiner Benutzer  ",
    "roleTypeList2": "Student  ",
    "roleTypeList3": "Elternteil  ",
    "roleTypeList101": "Agent Admin  ",
    "roleTypeList102": "Administrator  ",
    "roleTypeList301": "Super Admin  ",
    "userStatus1": "Aktiv  ",
    "userStatus2": "Blockiert  ",
    "userStatus3": "Löschen  ",
    "operate": "Aktionen  ",
    "dialogName": "Spitzname:  ",
    "dialogUserName": "Benutzer-ID:  ",
    "dialogUserNameDefined": "Benutzername:  ",
    "dialogPassword": "Passwort:  ",
    "dialogID": "Mitarbeiter-ID:  ",
    "dialogRole": "Rolle:  ",
    "dialogEmail": "E-Mail:  ",
    "dialogPhone": "Telefon:  ",
    "dialogGroup": "Gruppe:  ",
    "addUser": "Neuer Benutzer  ",
    "editUser": "Benutzer bearbeiten  ",
    "addSuccess": "Erfolgreich hinzugefügt!  ",
    "addError": "Fehler beim Hinzufügen!  ",
    "editSuccess": "Erfolgreich bearbeitet!  ",
    "editError": "Fehler bei der Bearbeitung!  ",
    "delSuccess": "Erfolgreich gelöscht!",
    "delError": "Fehler beim Löschen!  ",
    "cancel": "Abbrechen  ",
    "confirm": "Bestätigen  ",
    "save": "Speichern  ",
    "tableDel": "Löschen  ",
    "tableEdit": "Bearbeiten  ",
    "selectRoles": "Rollen auswählen  ",
    "delTitle": "Löschen?  ",
    "delTitleContent": "Der ausgewählte Inhalt wird aus der Datenbank gelöscht. Dieser Vorgang kann nicht rückgängig gemacht werden. Sind Sie sicher, dass Sie fortfahren möchten?  ",
    "delCancelButton": "Abbrechen  ",
    "delConfirmButton": "Bestätigen  ",
    "titleRealNameRq": "Dieses Feld muss ausgefüllt werden  ",
    "titleRealNameFormat": "Wählen Sie einen Benutzernamen, der nur aus Buchstaben und Zahlen besteht.  ",
    checkPasswordTitleTwo: 'Bitte legen Sie ein Passwort mit mindestens 6 Zeichen fest, das Buchstaben und Zahlen enthält. Sonderzeichen sind erlaubt (keine Einschränkungen).',
    checkPasswordTitle: 'Das Passwort muss mindestens 6 Zeichen lang sein und darf nicht nur aus Zahlen bestehen',
    "titlePhoneFormat": "Die Telefonnummer darf nur Zahlen, (), + und - enthalten.  ",
    "phoneFilled": "Die Telefonnummer muss ausgefüllt werden.  ",
    "titleEmaileFormat": "Fehler im E-Mail-Format.  ",
    "emaileFilled": "Die E-Mail muss ausgefüllt werden.  ",
    "titlUserNameDefinedNub": "Der Benutzername darf nicht mehr als 30 Zeichen umfassen  ",
    "titlRealNameNub": "Der Name darf nicht mehr als 30 Zeichen umfassen.  ",
    "titlRealNameField": "Der Name muss ausgefüllt werden.  ",
    "thisPasswordField": "Das Passwort muss ausgefüllt werden.  ",
    "titlPassWordNub": "Das Passwort muss zwischen 6 und 30 Zeichen lang sein  ",
    "enableStatus": "Benutzer aktivieren  ",
    "stopStatus": "Benutzer deaktivieren  ",
    "enableContent": "Sind Sie sicher, dass Sie den Benutzer aktivieren möchten?  ",
    "stopContent": "Sind Sie sicher, dass Sie den Benutzer deaktivieren möchten?  ",
    "error1400": "Benutzername existiert bereits, bitte versuchen Sie es erneut  ",
    "error1401": "Benutzer-ID existiert bereits und der Vorgang ist fehlgeschlagen!  ",
    "error1402": "Gruppe existiert nicht, Import fehlgeschlagen!  ",
    "error1403": "Daten sind falsch  ",
    "error1404": "Unzureichende Berechtigungen  ",
    "selUser": "Bitte wählen Sie einen Benutzer aus!  ",
    "error1405": "Fehler beim Abrufen der Rolle  ",
    "error1406": "Das Format der importierten Benutzerdaten ist falsch  ",
    "error1407": "Die E-Mail existiert bereits und der Vorgang ist fehlgeschlagen.  ",
    "error1408": "Die Telefonnummer existiert bereits und der Vorgang ist fehlgeschlagen.  ",
    "error1900": "Der aufgerufene Parameter ist leer  ",
    "error1610": "Bitte verwenden Sie die Terminal-Administratorrolle, um die entsprechenden Operationen auszuführen  ",
    "errorOrgIdList": "Gruppe kann nicht leer sein!  ",
    "Bindsucceeded": "Bindung erfolgreich  ",
    "Bindfailed": "Bindung fehlgeschlagen  ",
    "tableuserName": "Benutzername  ",
    "titleDevice": "Gerät  ",
    "bindDevice": "Gebundenes Gerät  ",
    "Bindcontrollable": "Gerät jetzt binden?  "
  },
  "devicesMge": {
    mustChooseOne: 'Wenn die intelligente Fernbedienung ausgewählt ist, muss mindestens ein Steuerbefehl ausgewählt werden',
    customName: 'Benutzerdefinierter Name',
    "testAcCode": "Neuen A/C-Steuerungscode testen",
    "Online": "Online",
    "Offline": "Offline",
    "unBindConfirm": "Bestätigen, um Serial zu trennen",
    "unBindConfirm485": "Bestätigen, um RS485 zu trennen",
    "notYetBoundRS232": "Das Gerät ist noch nicht mit einem Serial-Code verbunden. Sie können zu Gerät > Serial-Steuerungscode gehen, um ihn hinzuzufügen.",
    "RsFollowingFunctions": "Kann die folgenden Funktionen über Serial-Codes ausführen:",
    "Unbind": "Trennen",
    "Limit255": "Der Dateiname enthält maximal 255 Zeichen",
    "clear": "Löschen",
    "equipName": "Gerätename",
    "equipType": "Typ",
    "selectField": "Bitte wählen Sie eine Datei aus",
    "dialogTip": "*Wenn das Eingabefeld auf der rechten Seite leer ist, wird der Inhalt auf der linken Seite standardmäßig angezeigt",
    "dialogTipSingle": "*Wenn nur ein Gerät nicht benannt ist, verwenden Sie den Namen \"ALLE\"",
    "cantDelTemplateOne": "Der CBX von",
    cantDelTemplateTwo: 'Das CBX des Geräts „{deviceName}“ ist eine Vorlage. Möchten Sie es wirklich löschen?',
    "templateTitle": "Vorlagenersetzung",
    "templateContentOne": "Der Gerätename \"",
    "templateContentTwo": " wurde als gemeinsame CBX-Vorlage festgelegt. Möchten Sie das aktuelle Gerät wirklich als Vorlage festlegen?",
    "vcbNoTemplateNoSave": "Speichern ohne Vorlage nicht möglich",
    "vcbAcControl": "Wählen Sie ein A/C-Gerät aus",
    "vcbRemoteControl": "Wählen Sie ein Fernbedienungsgerät aus",
    "vcbPOWERControl": "Stromsteuerung",
    "vcbRS232Control": "Serial-Steuerung",
    "vcbIRControl": "IR-Steuerung",
    "vcbSetting": "CBX-Einstellungen",
    "editVcb": "CBX bearbeiten",
    "vcbName": "CBX-Name",
    "iot": "CBX-Steuerung",
    "saveAsTemplate": "Als Vorlage speichern",
    saveAsTemplatereplenish: 'Wählen Sie mehrere Geräte aus, um diese Vorlage im Kontrollzentrum zu verwenden',
    "Upload": "Hochladen",
    "Select": "Auswählen",
    "InputDeviceID": "Geräte-ID eingeben",
    "editNameTips": "* Der Inhalt links wird standardmäßig angezeigt, wenn das Eingabefeld rechts leer ist.",
    "_RS232A": "Schnittstelle eins",
    "_RS232B": "Schnittstelle zwei",
    "institutionDirectory": "Institutionenverzeichnis",
    "projectionScreenLinkageSetting": "Projektionseinstellungen für die Steuerung der Leinwand",
    "screenLiftingLinkageDisplaySwitch": "Steuerung der Projektion und Anzeigeverknüpfung:",
    "stopLinkage": "Deaktivieren (Steuerung der Projektionseinheit separat)",
    "Enable": "Aktivieren (Synchronisierte Steuerung der Projektionseinheit und Anzeige)",
    "btnAddDevice": "Gerät hinzufügen",
    "btnImportDevice": "Massenimport von Geräten",
    "btnDel": "Löschen",
    "btnEdit": "Bearbeiten",
    "tableIpAddress": "IP-Adresse",
    "MACAddress": "MAC-Adresse",
    "firmwareVersion": "Firmware-Version",
    "NA": "Nicht verfügbar",
    "tableDeviceName": "Gerätename",
    "tableStatus": "Status",
    "tableVideoSwitch": "Videoschalter",
    "tableAudio": "A/V-Verteilung",
    "tablePowerControl": "Stromsteuerung",
    "tableRS232": "Serielle Steuerung",
    "tableIR": "IR-Steuerung",
    "tableRFIDCard": "IC-Karte",
    "tableControlPanel": "Steuerfeld",
    "tableOrganization": "Gruppen",
    "tableActions": "Aktionen",
    "dialogAddTitle": "Gerät hinzufügen",
    "dialogEditTitle": "Gerät bearbeiten",
    "dialogBatchAddTitle": "Geräte massenhaft hinzufügen",
    "dialogBatchEditTitle": "Geräte massenhaft bearbeiten",
    "btnCancel": "Abbrechen",
    "Devices": "Geräte:",
    "ProjectorCode": "Serial Code:",
    "Group": "Gruppe:",
    "btnBatchAdd": "Massenhinzufügen",
    "delTitle": "Löschen?",
    "delTitleContent": "Die ausgewählten Komponenten werden aus der Datenbank gelöscht. Dieser Vorgang ist irreversibel. Möchten Sie fortfahren?",
    "delCancelButton": "Abbrechen",
    "delConfirmButton": "Bestätigen",
    "addError": "Hinzufügen fehlgeschlagen!",
    "editSuccess": "Erfolgreich bearbeitet!",
    "editError": "Bearbeitung fehlgeschlagen!",
    "delSuccess": "Erfolgreich gelöscht!",
    "delError": "Löschung fehlgeschlagen!",
    "content": "Suchen",
    "cancel": "Abbrechen",
    "confirm": "Bestätigen",
    "save": "Speichern",
    "tableDel": "Löschen",
    "tableEdit": "Bearbeiten",
    "selectRoles": "Rollen auswählen",
    "selectType": "Bitte wählen Sie einen Typ",
    "selectDevices": "Bitte wählen Sie ein Gerät",
    "titleRealNameRq": "Dieses Feld muss ausgefüllt werden",
    "titleRealNameNub": "Weniger als 100 Zeichen",
    "titlPassWordNub": "Weniger als 15 Zeichen",
    "error1900": "Der abgerufene Parameter ist leer",
    "error2000": "Die maximale Anzahl an verbindbaren Geräten wurde überschritten",
    "error2001": "Der importierte Gerätecode ist ungültig oder wurde noch nicht im System eingetragen.",
    "error2002": "Doppelt importierter Gerätename",
    "error2003": "Die importierte Geräte-ID wurde bereits verwendet",
    "error2004": "Fehlerhafte importierte Daten",
    "error2005": "Der Name der Marke oder des Modells ist mit bereits vorhandenen Daten im System identisch; bitte geben Sie der Marke oder dem Modell einen neuen Namen.",
    "error2008": "Dieses Gerät ist bereits einer anderen Gruppe zugeordnet",
    "notDevicesName": "Der Gerätename darf nicht leer sein",
    "notDevicesNO": "Die Geräte-ID darf nicht leer sein",
    "dialogDevicesName": "Gerätename:",
    "dialogDevicesID": "Geräte-ID:",
    "dialogProjectorCode": "Serial-Code:",
    "dialogGroup": "Gruppe:",
    "dialogSel": "Bitte wählen",
    "errorOrgIdList": "Die Gruppe darf nicht leer sein!",
    "errorDevicesName": "Der Gerätename darf nicht leer sein!",
    "errorDevicesNo": "Die Geräte-ID darf nicht leer sein!",
    "dialogTiltleDevices": "Geräte:",
    "uploadSuccess": "Upload erfolgreich",
    "addSuccess": "Hinzufügen erfolgreich",
    "ChooseGroups": "Wählen Sie die Gruppen",
    "ChooseIcon": "Wählen Sie ein Symbol",
    "dialogDevicesTitle": "Die Parameter Einstellungen werden auf die folgenden Geräte angewendet",
    "backDevice": "Zurück",
    "bootSetting": "Startoptionen",
    "nmpOpenSetting": "Einschalt-Einstellungen",
    "npsOpenSetting": "Einschalt-Einstellungen",
    "nmpPowerSettings": "Energieeinstellungen",
    "npsPowerSettings": "Energieeinstellungen",
    "nmpInterfaceSettings": "Schnittstelleneinstellungen",
    "npsInterfaceSettings": "Schnittstelleneinstellungen",
    "nmpDefaultChannel": "Standardkanaleinstellungen",
    "nmpCloseSetting": "Ausschalt-Einstellungen",
    "npsCloseSetting": "Ausschalt-Einstellungen",
    "SwipeToStart": "Sperre aktivieren (Karte berühren, um zu entsperren)",
    "ControlPanelToStart": "Sperre deaktivieren (uneingeschränkte Bedienung)",
    "Display": "Anzeige",
    "External": "Extern",
    "startingUpMethod": "Aktivieren/Deaktivieren der Panel-Sperre:",
    "startWith": "Starten mit:",
    "nmpstartWith": "Synchroner Einschaltvorgang:",
    "nmpcloseWith": "Synchroner Ausschaltvorgang:",
    "RS232Tip": "Wenn die Hauptstromversorgung ausgeschaltet wird, erhalten insgesamt 5 Serial-Schnittstellen, einschließlich Serial und bis zu 4 CBXs, den entsprechenden Abschaltbefehlscode.",

    startPowerTip: 'Beim Einschalten werden alle an die Stromschnittstellen des CBX angeschlossenen Geräte aktiviert.',
    startAirTip: 'Beim Einschalten werden alle verbundenen Klimaanlagen über Infrarot des Geräts/CBX einheitlich eingeschaltet.',
    startIrTip: 'Beim Einschalten wird über Infrarot des Geräts/CBX ein Steuerbefehl gesendet (z. B. Leinwand runter, Projektor an).',
    startRSTip: 'Beim Einschalten wird über die Serial-Schnittstelle des Geräts/CBX ein Einschaltbefehl gesendet.',
    CloseDisplayTip: 'An DISPLAY angeschlossene Geräte werden beim Herunterfahren von NDP/NMP automatisch ausgeschaltet. Diese Einstellung wird durch die Firmware gesteuert und kann nicht über die Software geändert werden.',
    CloseExternalTip: 'An EXTERNAL angeschlossene Geräte werden beim Herunterfahren von NDP/NMP automatisch ausgeschaltet. Diese Einstellung wird durch die Firmware gesteuert und kann nicht über die Software geändert werden.',
    ClosePowerTip: 'Beim Ausschalten werden alle an die Stromschnittstellen des CBX angeschlossenen Geräte deaktiviert.',
    CloseAirTip: 'Beim Ausschalten werden alle verbundenen Klimaanlagen über Infrarot des Geräts/CBX einheitlich ausgeschaltet.',
    CloseIrTip: 'Beim Ausschalten wird über Infrarot des Geräts/CBX ein Steuerbefehl gesendet (z. B. Leinwand hoch, Projektor aus).',
    CloseRSTip: 'Beim Ausschalten wird über die Serial-Schnittstelle des Geräts/CBX ein Ausschaltbefehl gesendet.',
    npsOpenRS232Tip: 'Wenn die Hauptstromversorgung eingeschaltet ist, erhalten die beiden seriellen Schnittstellen des NPS die entsprechenden Einschaltbefehls codes.',
    "npsRS232Tip": "Wenn die Hauptstromversorgung ausgeschaltet wird, erhalten die beiden Serial-Schnittstellen von NPS die entsprechenden Abschaltbefehls-Codes.",
    "useCardTip": "Nach dem Entsperren der Karte wird die Geräteversorgung automatisch aktiviert.",
    "npsCardTip": "Nach dem Entsperren der Karte wird die Hauptstromversorgung der Geräte automatisch aktiviert.",
    "PowerOutageHandling": "Stromausfallbehandlung",
    "PowerOutageHandTip": "Um den Zugang während unerwarteter Stromausfälle fortzusetzen, wählen Sie 'Entsperren bei Stromausfall'. Andernfalls wählen Sie 'Sperren bei Stromausfall', um den Zugang zu beschränken.",
    "acSetting": "A/C-Einstellung",
    "ChooseType": "Gerätetyp",
    "ChooseBrand": "Marke auswählen",
    "ChooseModel": "Modell auswählen",
    "btnConnectingTest": "Verbindungstest",
    "LockSetting": "Elektrische Schloss-Einstellung",
    "ElectricLockType": "Typ des elektrischen Schlosses:",
    "PowerUNLOCK": "Entsperren bei Stromausfall",
    "PowerLOCK": "Sperren bei Stromausfall",
    "none": "Keiner",
    "oddParity": "Ungerade Parität",
    "EvenParity": "Gerade Parität",
    "LastSetting": "Letzte Einstellung",
    "ElectricLockClosing": "Schließung des elektrischen Schlosses:",
    "manualSwitch": "Manueller Schalter",
    "Auto": "Auto (in",
    "projectorSetting": "Geräteauswahl und Bindung",
    "baudRate": "Baudrate",
    "Parity": "Parität",
    "ON": "Einschalten",
    "OFF": "Ausschalten",
    "Channel1": "Kanal 1",
    "Channel2": "Kanal 2",
    "PowerOffDelay": "Abschaltverzögerung",
    "second": "s",
    "DefaultChannel": "Standardkanal",
    "HDMIA": "HDMI Ausgang A:",
    "HDMIB": "HDMI Ausgang B:",
    "HDMIC": "HDMI Ausgang C:",
    "btnSaveApply": "Speichern und auf anwenden...",
    "btnSave": "Speichern",
    "btnCustomize": "Benutzerdefiniert",
    "ACIsPowerTitle": "Überprüfen, ob die Klimaanlage eingeschaltet ist?",
    "ACIsPowerContent": "Bitte schalten Sie die Klimaanlage vor dem Testen aus. Wenn sie nicht erfolgreich eingeschaltet wird, stellen Sie sicher, dass Marke und Modell der Klimaanlage korrekt sind.",
    "btnNextModel": "Nein, den nächsten Modell testen",
    "btnYes": "Ja",
    "errorConnecting": "Verbindungstest fehlgeschlagen",
    "hot": "HEISS",
    "_MAGNETICLOCK": "Elektronisches Schloss",
    "_AIR": "Klimaanlage",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    '_AUDIOA': 'HDMI out A',
    '_AUDIOB': 'Audio IN 1',
    '_AUDIOC': 'Audio IN 2',
    "_USB1": "USB 1",
    "_USB2": "USB 2",
    "_USB3": "USB 3",
    "_USBA": "USB A",
    "_USBB": "USB B",
    "IRControl": "IR Steuerungseinstellungen",
    "acControlTitle": "Wählen Sie ein A/C Gerät:",
    "acControlTitleNew": "A/C Gerät",
    "intelligentControlTitle": "Wählen Sie ein Fernsteuergerät:",
    "intelligentControlTitleNew": "Fernsteuergerät",
    "btnACControlCode": "Neuen A/C Steuercode identifizieren",
    "btnAddRemoteControl": "Neuer Fernbedienungscode",
    "ACControlCodeTitle": "A/C Steuercode identifizieren",
    "ACControlCodeseft1": "Code identifizieren",
    "ACControlCodeseft2": "Informationen hinzufügen",
    "btnStartIdentify": "Starten",
    "Identifysuccess": "Erfolgreich identifiziert!",
    "BeingIdentify": "Analyse läuft...",
    "acBrand": "A/C Marke",
    "acModel": "A/C Modell",
    "IdentifyFailureTitle": "Code nicht gefunden",
    "IdentifyFailureContent": "Die Identifikation ist fehlgeschlagen, dieses Modell wird derzeit nicht unterstützt. Bitte versuchen Sie die Fernbedienung",
    "btnTryAgain": "Erneut versuchen",
    "btnJump": "Zur Fernbedienung gehen",
    "ACrideo": "A/C",
    "ortherRideo": "Andere Geräte",
    "btnBack": "Zurück",
    "btnSortOut": "Zur Bearbeitung gehen",
    "remoteControlSeft1": "Gerätetyp auswählen",
    "remoteControlSeft2": "Code lernen",
    "remoteControlSeft3": "Informationen hinzufügen",
    "addRemoteControlError": "Entschuldigung, es können keine weiteren Codes gelernt werden. Bitte bearbeiten Sie zuerst die bestehenden Fernbedienungscodes",
    "btnPrevious": "Vorherige",
    "btnNextStep": "Nächste",
    "remoteControlErrorTitle": "Fehler beim Lernen des Codes",
    "remoteControlErrorContent1": "1. Der Infrarot-Sender ist nicht blockiert",
    "remoteControlErrorContent2": "2. Kein starkes Licht stört den Empfänger",
    "remoteControlErrorContent3": "3. Der Infrarot-Sender ist korrekt installiert",
    "remoteControlErrorContent4": "4. Die Fernbedienung funktioniert einwandfrei",
    "deviceItem1": "A/C",
    "deviceItem2": "Projektor",
    "deviceItem3": "TV",
    "deviceItem4": "Ventilator",
    "deviceItem5": "Licht",
    "deviceItem6": "Andere",
    "deviceItem7": "Interaktives Display",
    "deviceItem8": "Vorlesungsaufnahme-System",
    "deviceItem9": "PTZ-Kamera",
    "RS232protocol": "Serial-Protokoll:",
    "btnRemoteControl": "Lernen starten",
    "BeingIdentify1": "Analyse läuft...",
    "Identifysuccess1": "Erfolg",
    "controllerType1": "A/C",
    "controllerType2": "Serial",
    "controllerType3": "TV",
    "controllerType4": "Ventilator",
    "controllerType5": "Licht",
    "controllerType9": "Andere",
    "rqRemoteControlCode": "Bitte geben Sie den Namen des Fernbedienungscodes ein",
    "rqBrand": "Bitte geben Sie die Marke des A/C ein",
    "rqModel": "Bitte geben Sie das Modell des A/C ein",
    "error2016": "Der Name der Fernbedienung ist dupliziert, bitte geben Sie einen anderen ein",
    "RS232Setting": "Seriencode-Einstellung",
    "IR232Setting": "IR-Einstellung",
    "SystemError": "Systemfehler. Bitte versuchen Sie es erneut",
    "conditionerCodeContent": "Code für die Klimaanlage nicht gefunden, bitte versuchen Sie es erneut",
    "remoteControlCodeContent": "Code für die Fernbedienung nicht gefunden, bitte versuchen Sie es erneut",
    "btnRetry": "Erneut versuchen",
    "Bindusers": "Benutzer binden",
    "tablebinduser": "Benutzer binden",
    "Refresh": "Aktualisieren",
    "Binduserlable": "Benutzer binden, die das Gerät jetzt steuern können?",
    "SaveApplySuccessfully": "Erfolgreich speichern und anwenden",
    "DeviceType": "Typ:",
    "tableDeviceType": "Typ",
    "empty": "Es ist leer.",
    "sendCommand": "Später senden",
    "enable": "Aktivieren",
    "disable": "Deaktivieren",
    "SYNCremoteControl": "SYNC mit Fernbedienung",
    "analysisfailed": "Die Analyse ist fehlgeschlagen, bitte versuchen Sie es erneut",

    "CBX": {
      "powerSupplyON": "Einschalten",
      "powerSupplyOFF": "Ausschalten",
      "powerVcrON": "Aufnahme starten",
      "powerVcrOFF": "Aufnahme stoppen",
      "lockScreenON": "Sperre ein",
      "lockScreenOFF": "Sperre aus",
      "childLockON": "Kindersicherung ein",
      "childLockOFF": "Kindersicherung aus",
      "energySavingON": "Energiesparmodus ein",
      "energySaving": "Energiesparmodus",
      "energySavingOFF": "Energiesparmodus aus",
      "signalSourceSwitchingON": "OPS",
      "signalSourceSwitchingOFF": "Android",
      "volumeAdjustment": "Lautsprecher",
      "brightAdjustment": "Helligkeit",
      "other": "Weitere Funktionen...",
      "volumeExample": "Vollständige Serial-Steuerungsfunktion erforderlich für die vollständige Kompatibilität mit dem Aufnahmesystem.",
      "functionCode": "Funktion:",
      "Name": "Name:",
      "controlCode": "Steuerungscode:",
      "brand": "Marke:",
      "model": "Modell:",
      "errorBrandName": "Marke darf nicht leer sein!",
      "errorModelName": "Modell darf nicht leer sein!"
    }

  },
  "roleMge": {
    "role1": "Allgemeiner Benutzer",
    "role101": "Agent-Administrator",
    "role102": "Administrator",
    "role4": "Benutzerdefinierte Rolle",
    "roleNew": "Neue Rolle",
    "btnAddRole": "Rolle hinzufügen",
    "chooseUser": "Benutzer auswählen",
    "titleLevel": "Broadcasting-Property-Level:",
    "titleSettings": "Berechtigungseinstellungen:",
    "btnSave": "Speichern",
    "btnDelete": "Löschen",
    "cancel": "Abbrechen",
    "confirm": "Bestätigen",
    "save": "Speichern",
    "addSuccess": "Erfolgreich hinzugefügt!",
    "addError": "Fehler beim Hinzufügen!",
    "editSuccess": "Erfolgreich bearbeitet!",
    "editError": "Fehler beim Bearbeiten!",
    "delSuccess": "Erfolgreich gelöscht!",
    "delError": "Fehler beim Löschen!",
    "V3_0_OrganizationManage": "Gruppenverwaltung",
    "V3_0_UserManage": "Benutzerverwaltung",
    "V3_0_DeviceManage": "Gerätemanagement",
    "V3_0_CloudSpaceManage": "Cloud-Speicherverwaltung",
    "V3_0_OrganizationManage_View": "Ansehen",
    "V3_0_OrganizationManage_Edit": "Bearbeiten",
    "V3_0_UserManage_View": "Ansehen",
    "V3_0_UserManage_Edit": "Bearbeiten",
    "V3_0_DeviceManage_AddDevice": "Gerät hinzufügen",
    "V3_0_DeviceManage_Operating": "Betrieb",
    "V3_0_DeviceManage_Delete": "Löschen",
    "V3_0_DeviceManage_Edit": "Bearbeiten",
    "V3_0_CloudSpaceManage_PersonalManage": "Persönliche Cloud-Verwaltung",
    "V3_0_CloudSpaceManage_PublicManage": "Öffentliche Cloud-Verwaltung",
    "V3_0_CloudSpaceManage_SpaceManage": "Speicherzuweisung",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Betrieb",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Anzeigen",
    "V3_0_CloudSpaceManage_PublicManage_View": "Anzeigen",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Hochladen",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Herunterladen",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Datei löschen",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Ordner bearbeiten",
    "delTitle": "Löschen?",
    "delTitleContent": "Der ausgewählte Inhalt wird aus der Datenbank gelöscht. Dieser Vorgang kann nicht rückgängig gemacht werden. Sind Sie sicher, dass Sie fortfahren möchten?",
    "delCancelButton": "Abbrechen",
    "delConfirmButton": "Bestätigen",
    "btnAdd": "Rolle hinzufügen",
    "RoleName": "Rollenname:",
    "ManageRange": "Verwaltungsbereich:",
    "ChooseUser": "Benutzer auswählen:",
    "PermissionSettings": "Berechtigungseinstellungen:",
    "BroadcastingPropertyLevel": "Übertragungs-Property-Level",
    "ChooseGroups": "Gruppen auswählen",
    "ChooseTheUser": "Benutzer auswählen",
    "deleleTitle": "Die neue Rolle wurde nicht gespeichert. Wenn Sie den Bereich verlassen, wird die Rolle gelöscht. Möchten Sie wirklich den Bereich verlassen?",
    "Error1601": "Administrator kann nicht verwendet werden",
    "Error1602": "Fehler beim Abrufen der Berechtigungsrolle",
    "Error1603": "Nur Administratoren haben Zugriff auf diese Funktionen",
    "Error1604": "Der Rollenname darf nicht leer sein",
    "Error1605": "Die Gruppe darf nicht leer sein",
    "Error1606": "Diese Rolle existiert bereits",
    "Error1607": "Systemdefinierte Rolle, Modifikation nicht erlaubt",
    "Error1608": "Fehler beim Festlegen der Rolle",
    "Error1609": "Systemweiter Benutzerrolle, Modifikation nicht erlaubt",
    "Error1610": "Bitte verwenden Sie die Administratorrolle des Terminals, um die zugehörigen Vorgänge durchzuführen",
    "Error1611": "Verfügt nicht über die zugehörigen Rollenberechtigungen"
  },
  "projectorDevicesMge": {
    "tipOne": "1. Geben Sie den Funktionsnamen und den Steuercode ein. Beispiele für Steuercodes verwenden das HEX-Format.",
    "tipTwo": "2. Diese Oberfläche dient nur zur Konfiguration von seriellen Befehlen für Ein-/Ausschalten. Aktivieren Sie die Funktion unter 'Geräteverwaltung / Geräte / Vorgänge / Energieeinstellungen'.",
    "tipFunctionOne": "1. Wählen Sie häufig verwendete Funktionen aus der Dropdown-Liste aus. Die entsprechenden Symbole werden auf der seriellen Steuerungsoberfläche des Smart Panels angezeigt.",
    "tipFunctionTwo": "2. Die Befehle 'POWER ON' und 'POWER OFF' werden für die serielle Verknüpfung von Ein-/Ausschalten des Geräts verwendet. Auf dieser Seite werden nur Steuercodes konfiguriert. Aktivieren Sie die Verknüpfungsfunktion unter 'Geräteverwaltung / Geräte / Vorgänge / Energieeinstellungen'.",
    "ListRS232functions": "Liste der seriellen Steuerungsfunktionen",
    "Customizefunctionlist": "Funktionliste anpassen",
    "btnAddProjectorCode": "Seriencode hinzufügen",
    "btnDel": "Löschen",
    "inputSeach": "Suchen",
    "btnEdit": "Bearbeiten",
    "cancel": "Bereinigen",
    "confirm": "Bestätigen",
    "tableName": "Code-Name",
    "tablersType": "Gerätetyp:",
    "tablersTypeTable": "Gerätetyp",
    "tableModel": "Modell",
    "tableBrand": "Marke",
    "tableActions": "Aktionen",
    "dialogAddTitle": "Serial-Code hinzufügen",
    "dialogEditTitle": "Serial-Code bearbeiten",
    "brand": "Markenname:",
    "model": "Modell:",
    "baudRate": "Baudrate:",
    "parity": "Parität:",
    "powerOn": "EIN",
    "powerOff": "AUS",
    "pgrInput1": "Kanal 1",
    "pgbInput2": "Kanal 2",
    "delTitle": "Löschen?",
    "delTitleContent": "Der ausgewählte Inhalt wird aus der Datenbank gelöscht. Dieser Vorgang kann nicht rückgängig gemacht werden. Sind Sie sicher, dass Sie fortfahren möchten?",
    "delCancelButton": "Abbrechen",
    "delConfirmButton": "Bestätigen",
    "content": "Suchen",
    "operate": "Aktionen",
    "tableDel": "Löschen",
    "tableEdit": "Bearbeiten",
    "addSuccess": "Erfolgreich hinzugefügt!",
    "addError": "Hinzufügen fehlgeschlagen!",
    "editSuccess": "Erfolgreich bearbeitet!",
    "editError": "Bearbeitung fehlgeschlagen!",
    "delSuccess": "Erfolgreich gelöscht!",
    "delError": "Löschen fehlgeschlagen!",
    "selectTitle": "Bitte wählen Sie ein Serial aus!",
    "selectCode": "Serial auswählen",
    "none": "Keines",
    "oddParity": "Ungerade Parität",
    "EvenParity": "Gerade Parität"
  },
  "authorityMge": {
    "V3_0_OrganizationManage": "Gruppenverwaltung",
    "V3_0_UserManage": "Benutzerverwaltung",
    "V3_0_DeviceManage": "Gerätemanagement",
    "V3_0_CloudSpaceManage": "Cloud-Speicherverwaltung",
    "V3_0_OrganizationManage_View": "Ansehen",
    "V3_0_OrganizationManage_Edit": "Bearbeiten",
    "V3_0_UserManage_View": "Ansehen",
    "V3_0_UserManage_Edit": "Bearbeiten",
    "V3_0_DeviceManage_AddDevice": "Gerät hinzufügen",
    "V3_0_DeviceManage_Operating": "Betrieb",
    "V3_0_DeviceManage_Delete": "Löschen",
    "V3_0_DeviceManage_Edit": "Bearbeiten",
    "V3_0_DeviceManage_RepairLog": "Reparaturprotokoll",
    "V3_0_CloudSpaceManage_PersonalManage": "Persönliche Cloud-Verwaltung",
    "V3_0_CloudSpaceManage_PublicManage": "Öffentliche Cloud-Verwaltung",
    "V3_0_CloudSpaceManage_SpaceManage": "Cloud-Speicherverwaltung",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Betrieb",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Ansehen",
    "V3_0_CloudSpaceManage_PublicManage_View": "Ansehen",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Hochladen",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Herunterladen",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Löschen",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Bearbeiten",
    "delTitle": "Löschen?",
    "delTitleContent": "Die ausgewählten Komponenten werden aus der Datenbank gelöscht. Dieser Vorgang kann nicht rückgängig gemacht werden. Möchten Sie fortfahren?",
    "delCancelButton": "Abbrechen",
    "delConfirmButton": "Bestätigen",
    "content": "Suchen",
    "operate": "Aktion",
    "tableDel": "Löschen",
    "tableEdit": "Bearbeiten",
    "addSuccess": "Erfolgreich hinzugefügt!",
    "addError": "Hinzufügen fehlgeschlagen!",
    "editSuccess": "Erfolgreich bearbeitet!",
    "editError": "Bearbeiten fehlgeschlagen!",
    "delSuccess": "Erfolgreich gelöscht!",
    "delError": "Löschen fehlgeschlagen!",
    "selectTitle": "Bitte wählen Sie Serial aus!"
  },
  "workstationMge": {
    "priorChoice": "Übertragungspräferenz:",
    "SpeedPriority": "Geschwindigkeitspriorität",
    "SyncPriority": "Rahmensynchronisationspriorität",
    "SpeedPriorityTip": "Nachdem AV-Übertragungsbefehle gesendet wurden, können Q-NEX-Terminals die Wiedergabeaufgabe in kürzerer Pufferdauer von etwa 3-5 Sekunden ausführen. Die Geschwindigkeitspriorität wird empfohlen, wenn der Mediaserver im LAN arbeitet.",
    "SyncPriorityTip": "Nachdem AV-Übertragungsbefehle gesendet wurden, können Q-NEX-Terminals die Wiedergabeaufgabe synchron mit einer Pufferdauer von etwa 8-12 Sekunden ausführen.",
    "btnAddMedia": "Medienserver hinzufügen",
    "btnBack": "Zurück",
    "tableMediaLibId": "Medienserver-ID",
    "tableMediaLibName": "Medienserver-Name",
    "tableState": "Netzwerkstatus",
    "tableBindingUsers": "Gebundene Benutzer",
    "tableLiveAddress": "Übertragungsadresse",
    "tableAddress": "Streaming-Adresse",
    "tableOperate": "Aktionen",
    "tableDel": "Löschen",
    "tableEdit": "Bearbeiten",
    "titleMediaStation": "Übertragungsadresse",
    "titleLiveStation": "Streaming-Adresse:",
    "radioPublic": "Öffentlich",
    "radioPrivate": "Privat",
    "btnSave": "Speichern",
    "titleUsers": "Benutzer",
    "titleCanBe": "Kann gebunden werden",
    "titleHaveBeen": "Wurde gebunden",
    "titleMore": "Müssen mehr hinzugefügt werden?",
    "btnAdd": "Hinzufügen",
    "content": "Suchen",
    "tableName": "Name",
    "tableUserName": "Benutzername",
    "operate": "Aktionen",
    "affiliatedOrganization": "Gruppen",
    "dialogTitle": "Neuen Medienserver hinzufügen",
    "dialogTitleEdit": "Neuen Medienserver bearbeiten",
    "dialogItemName": "Name:",
    "dialogItemId": "ID:",
    "dialogItemIp": "Broadcast-Adresse:",
    "titleSelectUsers": "Benutzer auswählen",
    "selectMedia": "Bitte wählen Sie ein Medium",
    "delTitle": "Sind Sie sicher, dass Sie löschen möchten?",
    "delMediaLibTitle": "Löschbestätigung?",
    "delTitleContent": "Die ausgewählten Inhalte werden aus der Datenbank gelöscht. Dieser Vorgang kann nicht rückgängig gemacht werden. Sind Sie sicher, dass Sie fortfahren möchten?",
    "delTitleMediaLibContent": "Die Löschaktion führt dazu, dass die relevanten Daten gelöscht werden und nicht rückgängig gemacht werden können.",
    "delCancelButton": "Abbrechen",
    "delConfirmButton": "Bestätigen",
    "selectDevices": "Bitte wählen Sie Geräte aus",
    "selectUser": "Bitte wählen Sie Benutzer aus",
    "addUser": "Benutzer hinzufügen",
    "editUser": "Benutzer bearbeiten",
    "addSuccess": "Erfolgreich hinzugefügt!",
    "addError": "Fehler beim Hinzufügen!",
    "editSuccess": "Erfolgreich bearbeitet!",
    "editError": "Fehler beim Bearbeiten!",
    "delSuccess": "Erfolgreich gelöscht!",
    "delError": "Fehler beim Löschen!",
    "cancel": "Abbrechen",
    "confirm": "Bestätigen",
    "save": "Speichern",
    "error2500": "Die maximale Anzahl an Geräten, die mit der aktuellen Arbeitsstation verbunden werden können, wurde überschritten.",
    "DeviceName": "Gerätename",
    "AssociatedUserManagement": "Verwaltung der verbundenen Benutzer",
    "btnDel": "Löschen",
    "errorMsgId": "Diese ID konnte nicht gefunden werden",
    "LiveStreaming": "Streaming-Adresse:",
    "NoFoundMediaId": "Es konnte keine ID des Medienservers abgerufen werden",
    "AlreadyConnectedOrg": "Der Medienserver ist bereits mit einer anderen Organisation verbunden",
    "AlreadyBoundMedia": "Diese Organisation hat bereits einen Medienserver gebunden und kann keinen weiteren binden",
    "DeleteSecondaryConfirmation": "Die Daten können nach dem Löschen des Medienservers nicht wiederhergestellt werden, bitte bestätigen Sie erneut."
  },
  "cloudDiskMge": {
    "totalStorage": "GESAMTSPEICHER",
    "GetMore": "Mehr erhalten",
    "StorageSpace": "Speicherplatz",
    "Adjustment": "Anpassung",
    "moreSpace": "Mehr Speicherplatz erhalten",
    "PublicStorage": "Öffentlicher Speicher",
    "PublicStorageUsed": "Genutzter öffentlicher Speicher",
    "PublicStorageLasted": "Verbleibender öffentlicher Speicher",
    "IndividualStorageUsed": "Genutzter persönlicher Speicher",
    "IndividualStorageLasted": "Verbleibender persönlicher Speicher",
    "storageSpace": "Speicherplatzanpassung",
    "tableUserName": "Benutzername",
    "tableUsedSpace": "Genutzter Speicher",
    "tableAvailableSpace": "Verfügbarer Speicher",
    "tableActiveTime": "Letzte aktive Zeit",
    "tableOperate": "Aktionen",
    "cleanup": "Hinweis zur Bereinigung",
    "IndividualStorageSpaceAdjustment": "Anpassung des persönlichen Speicherplatzes",
    "titleTotal": "Gesamt",
    "PublicDisk": "Öffentliche Cloud",
    "IndividualDisk": "Persönliche Cloud",
    "PerUser": "Pro Benutzer",
    "UsersInTotal": "Gesamtzahl der Benutzer",
    "cancel": "Abbrechen",
    "confirm": "Bestätigen",
    "save": "Speichern",
    "addSuccess": "Erfolgreich hinzugefügt!",
    "addError": "Hinzufügen fehlgeschlagen!",
    "editSuccess": "Erfolgreich bearbeitet!",
    "editError": "Bearbeitung fehlgeschlagen!",
    "delSuccess": "Erfolgreich gelöscht!",
    "delError": "Löschen fehlgeschlagen!",
    "error3000": "Die Operation ist fehlgeschlagen, da die gesamte Speichergröße überschritten wurde.",
    "error3003": "Fehlgeschlagene Operation, bitte überprüfen Sie, ob ein Medienserver eingerichtet wurde.",
    "IndividualStorage": "Persönlicher Speicher",
    "NoteToCleanup": "Hinweis zur Bereinigung",
    "updatePersonalSuccess": "Ihr Cloud-Speicherplatz wird voll sein, bitte bereinigen Sie rechtzeitig",
    "updatePersonalSuccess1": "Erfolgreich geändert und gespeichert",
    "storageUsage": "Verwendung des persönlichen Speichers",
    "bindIndividualstorage": "Benutzer dürfen persönlichen Cloud-Speicher haben",
    "UserIndividualstorage": "Benutzer haben bereits persönlichen Cloud-Speicher eingerichtet",
    "Notificationsuccessfully": "Benachrichtigung erfolgreich gesendet",
    "Notificationfailed": "Benachrichtigung gesendet fehlgeschlagen",
    "tableName": "Name",
    "userID": "Benutzer-ID"
  },
  "dashboard": {
    "exportPdf": "PDF exportieren",
    "or": "-",
    "warrantyCompletionRate": "Reparaturquote",
    "frequencyOfEachModule": "Der Reparaturprozentsatz für jedes funktionale Modul",
    "repairHandling": "Bearbeitungsstatus der Reparatur",
    "sourceSwitchInput": "Eingangsschalter",
    "micVol": "Mikrofonlautstärke",
    "volumeSpeaker": "Lautsprecherlautstärke",
    "airAonditioner": "Klimaanlage",
    "Curtain": "Projektorbildschirm",
    "remoteControlIntelligent": "Fernbedienung",
    "RS232Control": "Serial-Steuerung",
    "lockElectronic": "Elektronische Schlösser",
    "Repairreportcompleted": "Repariert",
    "Totalnumberofrepairsreported": "Gesamtanzahl der Reparaturen",
    "Warrantycompletionrate": "Reparaturabschlussrate",
    "startDate": "Startdatum",
    "endDate": "Enddatum",
    "year": "Jahr",
    "month": "Monat",
    "dayTian": "Tag",
    "placeholderDate": "Datum auswählen",
    "placeholderDateTime": "Uhrzeit auswählen",
    "devicesNub": "Geräte",
    "userNub": "Benutzer",
    "powerNub": "Leistung (KW/H)",
    "storageUsed": "Genutzter Speicher (%)",
    "userLoginDevice": "Aktive Benutzer-Login-Zeit",
    "devicePowerConsumption": "Täglicher Stromverbrauch aller Geräte",
    "externalDeviceUsageTime": "Externe Geräteverwendung",
    "equipmentRunningTime": "Terminalgeräteverwendung",
    "cloudStorageSpace": "Speichernutzung",
    "powerConsumptionPort": "Stromverbrauch jedes Stromports",
    "mostPopularFile": "Beliebteste Datei",
    "commonFunctions": "Häufig verwendete Funktionen",
    "commonlyUsed": "Häufigste Broadcast-Methode",
    "fileName": "Dateiname",
    "usageCount": "Verwendungsanzahl",
    "electricityConsumption": "Stromverbrauch",
    "publicStorageUsed": "Genutzter öffentlicher Speicher",
    "publicStorageLasted": "Verbleibender öffentlicher Speicher",
    "individualStorageUsed": "Genutzter individueller Speicher",
    "individualStorageLasted": "Verbleibender individueller Speicher",
    "notification": "Benachrichtigung",
    "audioBroadcast": "Audioübertragung",
    "videoBroadcast": "Videoübertragung",
    "ac": "Klimaanlage",
    "hDMISwitch": "HDMI-Schalter",
    "powerControl": "Energieverwaltung",
    "powercontrol": "Energieverwaltung",
    "Lock": "Sperren",
    "volumeAdjust": "Lautstärkeregler",
    "projectionScreen": "Projektionsbildschirm",
    "today": "Heute",
    "yesterday": "Gestern",
    "thisWeek": "Diese Woche",
    "lastWeek": "Letzte Woche",
    "lastMonth": "Letzten Monat",
    "thisMonth": "Diesen Monat",
    "times": "Mal",
    "usage": "Verwendungsanzahl",
    "eachrTitle": "Minuten",
    "total": "Gesamt",
    "NMPSystemissue": "NMP-Systemproblem",
    "displayPower": "Externes Gerät Problem (NMP)",
    "externalPower": "MBX-Systemproblem",
    "screen": "Externes Gerät Problem (MBX)",
    "TotalRepairs": "Gesamtzahl der Reparaturen",
    "Repaired": "Repariert",
    "Unrepaired": "Nicht repariert",
    "day": "TAG",
    "Minutes": "Minuten",
    "powerConsumption": "Minuten",
    "Date": "Datum",
    "kw": "KW",
    "month1": "MO",
    "month2": "DI",
    "month3": "MI",
    "month4": "DO",
    "month5": "FR",
    "month6": "SA",
    "month7": "SO",
    "enmonth1": "Jan",
    "enmonth2": "Feb",
    "enmonth3": "März",
    "enmonth4": "Apr",
    "enmonth5": "Mai",
    "enmonth6": "Juni",
    "enmonth7": "Juli",
    "enmonth8": "Aug",
    "enmonth9": "Sep",
    "enmonth10": "Okt",
    "enmonth11": "Nov",
    "enmonth12": "Dez",
    "noData": "Keine Daten"
  },
  "input": {
    "fivedigits": "Bitte geben Sie eine positive ganze Zahl mit 5 Ziffern ein",
    "titlUserNameField": "Dieser Benutzername muss ausgefüllt werden",
    "thisField": "Dieses Feld muss ausgefüllt werden",
    "ChooseGroup": "Gruppe auswählen",
    "placeholder": "Auswählen",
    "placeholder_type": "Bitte wählen Sie die Gerätetypen für die Steuerung aus",
    "titlRealNameField": "Das Passwort muss ausgefüllt werden",
    "thisPasswordField": "Das Passwort muss ausgefüllt werden",
    "titlPassWordNub": "Weniger als 15 Buchstaben",
    "Post": "Nur Zahlen",
    "passwordNoChinese": "Dieses Eingabefeld darf nicht mit chinesischen Zeichen gefüllt werden"
  },
  "transfer": {
    "all": "Alle",
    "Choose": "Wählen",
    "Selected": "Ausgewählt",
    "Subordinate": "Untergeordnet"
  },
  "setting": {
    limitPngGif: 'Nur PNG- / GIF-Formate werden unterstützt',
    limit3M: 'Die Bildgröße darf 3 MB nicht überschreiten',
    setting_door_Wallpaper_text: 'Empfohlene Bildgröße: 1280x800, PNG- oder GIF-Format',

    "reduction": "Wiederherstellen",
    "limitJpg": "Das hochgeladene Profilbild kann nur im PNG-Format vorliegen!",
    "limit2M": "Die Größe des hochgeladenen Profilbildes darf 2 MB nicht überschreiten!",
    "choseFile": "Datei auswählen",
    "textOne": "1. Empfohlene LOGO-Bildgröße: 117*40, im PNG-Format",
    "textTwo": "2. Nach dem Hochladen bitte zum Touch-Panel gehen, sicherstellen, dass das Touch-Panel mit dem Internet verbunden ist, und dann auf das ursprüngliche Logo klicken, um es zu aktualisieren.",
    "customizeLogo": "Touch-Panel-Logo-Einstellungen",
    "addSuccess": "Einstellung erfolgreich!",
    "settingIp": "Datei-Speicher-IP-Einstellungen",
    "ServerIP": "Server-IP-Adresse:",
    "ServerPort": "Server-Port:",
    "btnSave": "Speichern",
    "TimeZoneSetting": "Zeitzoneneinstellungen",
    "CurrentTime": "Aktuelle Zeit:",
    "CurrentTimeZone": "Aktuelle Zeitzone:",
    "httpsSetting": "Dateispeicher:",
    "utcName": "Greenwich Mean Time UTC/GMT",
    "utc0": "Greenwich Mean Time, Vereinigtes Königreich, Lissabon, Torshavn, London, Dublin, Edinburgh",
    "utc0_5": "",
    "utc1": "Zentraleuropa, Westafrika, Westzentralafrika, Deutschland, Irland, Frankreich, Amsterdam, Italien, Berlin, Rom, Spanien, Prag, Belgrad, Brüssel, Paris, Madrid, Tunesien, Gabun, Marokko",
    "utc1_5": "",
    "utc2": "Osteuropa, Zentralafrika, Türkei, Israel, Südafrika, Istanbul, Kairo, Athen, Damaskus",
    "utc2_5": "",
    "utc3": "Ostafrika, Russland, Bagdad, Kuwait, Moskau, St. Petersburg",
    "utc3_5": "Iran",
    "utc4": "Abu Dhabi, Tiflis, Dubai, Mauritius, Port Louis",
    "utc4_5": "Afghanistan",
    "utc5": "Pakistan, Turkmenistan, Malediven, Usbekistan, Armenien, Tadschikistan Indien, Mumbai, Neu-Delhi, Bangalore, Kalkutta",
    "utc5_5": "Indien, Sri Lanka",
    "utc6": "Nowosibirsk, Kirgisistan, Bangladesch, Bhutan",
    "utc6_5": "Kokosinseln Australien, Vietnam",
    "utc7": "Thailand, Bangkok, Hanoi, Jakarta",
    "utc7_5": "",
    "utc8": "China, Malaysia, Philippinen, Singapur, Taiwan China, Macao China, Hongkong China",
    "utc8_5": "",
    "utc9": "Japan, Südkorea, Tokio, Seoul, Sapporo, Osaka, Osttimor",
    "utc9_5": "Australische Zentralzeit (Standardzeit)",
    "utc10": "Australien, Wladiwostok, Guam, Canberra, Melbourne, Sydney, Papua-Neuguinea",
    "utc10_5": "Lord Howe Island von New South Wales, Australien",
    "utc11": "Salomonen, Sachalin-Insel",
    "utc11_5": "Norfolkinsel, Australien",
    "utc12": "Neuseeland, Auckland, Wellington, Fidschi, Neuseeland, Nauru",
    "utc12_5": "",
    "utc13": "Kap Verde, Azoren",
    "utc13_5": "",
    "utc14": "Südgeorgien, Fernando de Noronha",
    "utc14_5": "",
    "utc15": "Brasilien, Santiago, El Salvador, Brasília, Uruguay, Argentinien, Suriname",
    "utc15_5": "Neufundland-Standardzeit",
    "utc16": "Venezuela, Bolivien, Paraguay, Chile",
    "utc16_5": "Venezuela",
    "utc17": "Ostzeit (USA und Kanada), Kolumbien, Toronto, Ecuador, Peru, Kuba, New York, Hamilton, San Diego",
    "utc17_5": "",
    "utc18": "USA und Kanadische Zentralzeit, Mexiko-Stadt, Monterrey, Chicago, Houston, New Orleans, Memphis",
    "utc18_5": "",
    "utc19": "Bergzeit, Arizona, Mazatlán, Phoenix, Salt Lake City, Denver, Edmonton",
    "utc19_5": "",
    "utc20": "Pazifikzeit, Los Angeles, San Francisco, Vancouver, Seattle, Las Vegas",
    "utc20_5": "",
    "utc21": "Alaska",
    "utc21_5": "Französisch-Polynesien, Marquesas-Inseln",
    "utc22": "Hawaii",
    "utc22_5": "",
    "utc23": "Samoa, Niue",
    "utc23_5": "",
    "utc24": ""
  },
  "repairLog": {
    "DeviceName": "Gerätename:",
    "Time": "Zeit:",
    "startDate": "Startdatum",
    "endedDate": "Enddatum",
    "or": "-",
    "Problem": "Problem:",
    "btnSearch": "Suchen",
    "tableNO": "Nein",
    "tableDeviceName": "Gerätename",
    "tableGroup": "Gruppe",
    "tableStatus": "Status",
    "tableDeliveredTime": "Lieferzeit",
    "tableSubmitter": "Absender",
    "tableUpdatingTime": "Aktualisierungszeit",
    "tableProblem": "Problem",
    "tableAdmin": "IT-Admin",
    "tableAdminReply": "Admin-Antwort",
    "tableAttachment": "Anhang",
    "state0": "Geliefert",
    "state1": "In Bearbeitung",
    "state2": "Abgeschlossen",
    "Problem100": "ALLES",
    "Problem0": "Systemproblem",
    "Problem1": "Externes Geräteproblem",
    "ProblemType": "",
    "ProblemType0": "Stromsteuerung",
    "ProblemType1": "HDMI-Schalter",
    "ProblemType2": "Mikrofon",
    "ProblemType3": "Lautsprecher",
    "ProblemType4": "Klimaanlage",
    "ProblemType5": "Projektorleinwand",
    "ProblemType6": "Elektronisches Schloss",
    "ProblemType7": "A/V-Übertragung",
    "ProblemType8": "IR-Steuerung",
    "ProblemType9": "Serial-Steuerung",
    "dialogDeviceName": "Gerätename",
    "dialogDeviceID": "Geräte-ID",
    "dialogGroup": "Gruppe",
    "dialogSubmitter": "Absender",
    "dialogStatus": "Wählen Sie den Status",
    "dialogProblem": "Problem",
    "dialogNotes": "Notizen",
    "dialogRepairation": "Reparatur",
    "dialogInProcess": "In Bearbeitung",
    "dialogCompleted": "Abgeschlossen",
    "editSuccess": "Erfolgreich bearbeitet!",
    "editError": "Fehler beim Bearbeiten!",
    "problemRequired": "Bitte wählen Sie einen Problemtyp",
    "detailRequired": "Bitte beschreiben Sie das Problem im Detail",
    "statusRequired": "Bitte wählen Sie den Log-Status",
    "btnCancel": "Abbrechen",
    "DeliveredTime": "Lieferzeit",
    "UpdatingTime": "Aktualisierungszeit",
    "ITAdmin": "IT-Admin",
    "AdminReply": "Admin-Antwort",
    "Note": "Hinweis",
    "Detail": "Details",
    "controlPanel": "Steuerfeld",
    "DeviceType": "Typ",
    "dialogDeliveredTime": "Lieferzeit",
    "Submitter": "Absender"
  },
  "remoteControl": {
    "QuickActionName": "Name",
    "DeviceType": "Typ",
    "Description": "Beschreibung",
    "tableDescription": "Beschreibung",
    "editRemoteControl": "Fernbedienungscode bearbeiten",
    "QuickActionNameInput": "Name",
    "DescriptionInput": "Beschreibung",
    "save": "Speichern",
    "Brand": "Marke",
    "Model": "Modell",
    "EditACControlCode": "AC-Steuerungscode bearbeiten",
    "acBrand": "AC-Marke",
    "acModel": "AC-Modell"
  },
  "card": {
    "btnAddCard": "Karte hinzufügen",
    "btnBatchAddCard": "Karten im Batch hinzufügen",
    "tableCard": "Kartennummer",
    "tableState": "Status",
    "tableUser": "Benutzer binden",
    "tableID": "Benutzername",
    "tableType": "Kartentyp",
    "tableFfective": "Ablaufdatum",
    "dialogCard": "Kartennummer :",
    "dialogState": "Status :",
    "dialogUser": "Benutzer binden :",
    "dialogID": "Benutzername :",
    "dialogType": "Kartentyp :",
    "dialogFfective": "Ablaufdatum :",
    "dialogRemarks": "Bemerkungen :",
    "dialogAddTitle": "Karte hinzufügen",
    "dialogEidtTitle": "Karte bearbeiten",
    "code2201": "Das Ablaufdatum-Format der Karte ist falsch",
    "code2202": "Diese Karte ist bereits gebunden",
    "code2203": "Dieser Benutzer ist bereits gebunden",
    "code2204": "Diese Karte ist nicht gebunden",
    "mastCard": "Masterkarte",
    "regularCard": "Generalkarte",
    "permanent": "Permanent",
    "coxPermanent": "Permanent",
    "coxTime": "Bestimmte Zeitdauer",
    "tableDeviceName": "Gerätename",
    "tableDeviceID": "Geräte-ID",
    "tableOperating": "Betrieb",
    "tableOperatingTime": "Betriebszeit",
    "tableCardID": "Kartennummer",
    "tableCardType": "Kartentyp",
    "tabluserName": "Benutzername",
    "tabluserId": "Benutzer-ID",
    "unlockPanel": "Panel entsperren",
    "unlock": "Tür entsperren",
    "conAll": "Alles",
    "btnEnable": "Aktivieren",
    "btnDisable": "Deaktivieren",
    "enableSuccess": "Erfolgreich aktiviert",
    "stopSuccess": "Erfolgreich deaktiviert",
    "enableError": "Fehler beim Aktivieren",
    "stopError": "Fehler beim Deaktivieren",
    "batchCard": "Batch-Kartennummer :",
    "titlCardField": "Kartennummer darf nicht leer sein",
    "titlCardFieldFormat": "Nur Buchstaben und Zahlen",
    "dialogBachAddTitle": "Batch-Karten hinzufügen",
    "pleaseTryAgain1": "Falsche Kartennummer (NO. :",
    "pleaseTryAgain2": "), bitte versuchen Sie es erneut"
  },
  privacy: {
    PrivacyPolicy: 'Microsoft Organization Binding Privacy Agreement',
    Byusing: 'Dear User,',
    whatinformation: 'Before authorizing Q-NEX to access Microsoft data, please read this agreement carefully. This document is a supplement to the Q-NEX Privacy Policy, and it specifically explains the permissions required for synchronization, the purposes of data usage, and our protection measures. By checking “Agree,” you confirm that you have read and accepted all terms of this agreement.',
    EffectiveDate: 'Effective Date: August 4, 2025',
    title1: 'Required Permissions & Collected Data',
    title1Respects1: 'To enable synchronization between Q-NEX Room Scheduler and Microsoft Calendar, Q-NEX requires the following Microsoft permissions:',
    title1Respects2: 'Delegated Permissions',
    Respects2formation: 'These permissions allow Q-NEX to access your Microsoft account data after login and consent:',
    Respects2formation2: 'Calendars.ReadWrite',
    Respects2formation3: 'Permission Name: Full access to user calendars',
    Respects2formation4: 'Description: Allows the app to create, read, update, and delete events in user calendars.',
    Respects2formation5: 'Purpose: Synchronize personal calendar meetings with the Q-NEX system.',
    Respects2formation6: 'offline_access',
    Respects2formation7: 'Permission Name: Maintain access to data you’ve granted',
    Respects2formation8: 'Description: Allows the app to access authorized data even when you’re not actively using it.',
    Respects2formation9: 'Purpose: Ensures meeting information remains synced even when users are offline.',
    Respects2formation10: 'Openid',
    Respects2formation11: 'Permission Name: Sign in as you',
    Respects2formation12: 'Description: Enables login via work/school accounts and allows the app to read basic profile details.',
    Respects2formation13: 'Purpose: Authenticates user identity for security and associates profiles with meeting data.',
    Respects2formation14: 'Place.Read.All',
    Respects2formation15: 'Permission Name: Read all company places',
    Respects2formation16: 'Description: Allows the app to read company locations (meeting rooms and room lists) on your behalf.',
    Respects2formation17: 'Purpose: Retrieves company room resource lists and syncs meeting room booking statuses.',

    tp1: 'Application Permissions (Requires Admin Consent)',
    tp2: 'These permissions enable Q-NEX to sync data automatically without manual reauthorization:',
    tp3: 'Calendars.ReadWrite',
    tp4: 'Permission Name: Read and write calendars in all mailboxes',
    tp5: 'Description: Allows the app to create, read, update, and delete calendar events without user sign-in.',
    tp6: 'Purpose: Syncs schedules from all company meeting room resource mailboxes.',
    tp7: 'Directory.Read.All',
    tp8: 'Permission Name: Read directory data',
    tp9: 'Description: Allows the app to read organizational directory data (users, groups, apps) without user sign-in.',
    tp10: 'Purpose: Validates meeting room resource mailboxes and retrieves organizational structure.',
    tp11: 'User.Read.All',
    tp12: 'Permission Name: Read all users’ full profiles',
    tp13: 'Description: Allows the app to read user profiles without user sign-in.',
    tp14: 'Purpose: Identifies meeting participants.',
    tp15: 'Place.Read.All',
    tp16: 'Permission Name: Read all company places',
    tp17: 'Description: Allows the app to read company locations (meeting rooms and room lists) for calendar events and other apps without user sign-in.',
    tp18: 'Purpose: Retrieves full meeting room resource lists and syncs availability statuses.',

    title2: 'Purpose of Data Usage',
    title2Respects1: 'Sync Microsoft Calendar meetings to Q-NEX for real-time display on the Room Scheduler.',
    title2Respects2: 'Automatically update room availability to prevent scheduling conflicts.',
    title2Respects3: 'Provide a unified meeting management experience.',

    title3: 'Data Storage & Protection',
    title3Respects1: 'All synced data is encrypted and stored on Q-NEX servers, used solely for this functionality.',
    title3Respects2: 'Q-NEX does not share calendar data with third parties unless legally required or for system security.',
    title3Respects3: 'For cross-border data transfers, we will ensure compliance with applicable laws through contractual terms or certification mechanisms.',

    title4: 'Your Rights',
    title4Respects1: 'You may unbind your Microsoft account at any time via the Q-NEX Console to stop data synchronization.',

    title5: 'Important Notes',
    title5Respects1: 'Please ensure you have administrative rights or legal authorization for the Microsoft account you bind.',
    title5Respects2: 'Once unbound, Q-NEX will stop syncing new data, but historical data may be retained for a certain period as required by compliance obligations.',

    contactInformation: 'Contact Information',
    contactInformationContent: 'If you have any questions, please contact: info@qnextech.com',

  }
}



// WEBPACK FOOTER //
// ./src/lang/de.js